export const EXTRA_TRANSLATIONS = {
  de: {
    dailyIntro: "Where flavor meets wellness.",
    allMealsIntro: "Entdecken Sie Rezepte nach Mahlzeit, Küche, Kategorie und Kalorien.",
    dessertsIntro: "Entdecken Sie cremige, fruchtige, leichte und internationale Desserts mit Kalorienangaben.",
    all: "Alle",
    fitHealthy: "Fit / gesund",
    allMealsFilter: "Alle Mahlzeiten",
    allCuisines: "Alle Küchen",
    allWorldCuisines: "Alle Weltküchen",
    allDessertTypes: "Alle Dessertarten",
    dessertType: "Dessertart",
    newPlan: "Neuer Plan",
    loadingDaily: "Tagesplan wird vorbereitet...",
    loadingMeals: "Gerichte werden geladen...",
    loadingDesserts: "Desserts werden geladen...",
    totalDailyCalories: "Geschätzte Gesamtkalorien der drei Hauptmahlzeiten heute",
    cachedPlan: "Der heutige Plan wurde aus dem Speicher geladen.",
    noMealFound: "Kein Gericht gefunden",
    noDessertFound: "Kein Dessert gefunden",
    tryDifferentFilters: "Ändern Sie die Filter und versuchen Sie es erneut.",
    mealsFound: "Gerichte gefunden",
    dessertsFound: "Desserts gefunden",
    noSlotSuggestion: "Für diese Filter wurde kein Vorschlag gefunden.",
    searchMeals: "Gericht, Küche oder Zutat suchen...",
    searchDesserts: "Dessert oder Zutat suchen...",
    minutes: "Min.",
    kcal: "kcal",
    ingredientUnit: "Zutaten",
    addOwnRecipe: "Eigenes Rezept hinzufügen",
    addRecipeIntro: "Speichern Sie eigene Gerichte oder Desserts in wenigen Schritten.",
    addRecipeLoginNote: "Sie müssen sich anmelden, bevor Sie ein Rezept hinzufügen.",
    recipeName: "Rezeptname",
    mealType: "Mahlzeit",
    calories: "Kalorien",
    prepTime: "Vorbereitung",
    cookTime: "Kochen",
    prepMinutes: "Vorbereitung (Min.)",
    cookMinutes: "Kochen (Min.)",
    servings: "Portionen",
    ingredients: "Zutaten",
    steps: "Zubereitungsschritte",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saving: "Wird gespeichert...",
    recipeSaved: "Rezept gespeichert",
    ingredientsPlaceholder: "Eine Zutat pro Zeile schreiben oder mit Kommas trennen",
    stepsPlaceholder: "Einen Schritt pro Zeile schreiben",
    recipeNamePlaceholder: "Beispiel: Hausgemachte Gemüsepasta",
    rateRecipe: "Dieses Rezept bewerten",
    socialInfo: "Die Social-Login-Struktur ist bereit. Echte OAuth-Schlüssel können später verbunden werden.",
    favoriteAdd: "Zu Favoriten hinzufügen",
    favoriteRemove: "Aus Favoriten entfernen",
    favoriteAdded: "Zu Favoriten hinzugefügt",
    favoriteRemoved: "Aus Favoriten entfernt",
    back: "Zurück",
    backToMeals: "Zurück zu den Gerichten",
    noMealSelected: "Kein Gericht ausgewählt",
    addAllIngredients: "Zutaten zur Liste hinzufügen",
    addToList: "+ Liste",
    added: "Hinzugefügt",
    alreadyOnList: "Bereits auf der Liste",
    ingredientAdded: "zur Liste hinzugefügt",
    ingredientsAddedToShopping: "Zutaten zur Einkaufsliste hinzugefügt",
    videoRecipe: "Videorezept",
    rateLoginRequired: "Melden Sie sich an, um zu bewerten.",
    ratingSaved: "Bewertung gespeichert",
    noRatingYet: "Noch keine Bewertungen",
    dietitianIntro: "Jeden Tag kurze, praktische Tipps für Ernährung und Lebensstil.",
    dailyNutritionAdvice: "Täglicher Ernährungs- und Lebensstiltipp",
    dailyTips: "Tipps des Tages",
    suggestedFoodToday: "Empfohlenes Lebensmittel heute:",
    adviceLoading: "Tipp des Tages wird vorbereitet...",
    adviceLoadFailed: "Tipp konnte nicht geladen werden",
    checkBackendOrKey: "Backend-Verbindung oder API-Schlüssel prüfen.",
    askDietitian: "Ernährungsberater fragen",
    medicalDisclaimer: "Dieser Bereich dient allgemeinen Informationen und ersetzt keine Diagnose oder Behandlung.",
    askPlaceholder: "Beispiel: Was kann ich für ein leichteres Abendessen wählen?",
    answerPreparing: "Antwort wird vorbereitet...",
    cannotAnswerNow: "Ich kann gerade nicht antworten. Bitte versuchen Sie es später erneut.",
    wait: "Warten",
    ask: "Fragen",
    favoritesIntro: "Greifen Sie schnell auf Lieblingsgerichte und Desserts zu.",
    noFavorites: "Noch keine Favoriten",
    favoriteHint: "Tippen Sie auf das Herz, um Rezepte zu speichern.",
    browseMeals: "Gerichte ansehen",
    favoriteRecipeCount: "Lieblingsrezepte",
    shoppingIntro: "Verfolgen Sie fehlende Zutaten aus Rezepten dauerhaft.",
    list: "Liste",
    waiting: "wartet",
    completed: "erledigt",
    clearCompleted: "Erledigte löschen",
    emptyList: "Liste ist leer",
    shoppingEmptyHint: "Fügen Sie Zutaten aus Rezeptdetails hinzu.",
    purchased: "Gekauft",
    addNewIngredient: "Neue Zutat hinzufügen...",
    add: "Hinzufügen",
    delete: "Löschen",
    purchasedCleared: "Gekaufte Artikel gelöscht",
    ingredientSuggest: "Nach Zutaten vorschlagen",
    ingredientSuggestIntro: "Geben Sie vorhandene Zutaten ein, wir finden passende Rezepte.",
    yourIngredients: "Ihre Zutaten",
    addIngredientPlaceholder: "Zutat hinzufügen (z. B. Tomate, Ei...)",
    searching: "Suche...",
    findRecipe: "Rezepte finden",
    clear: "Leeren",
    searchingRecipes: "Rezepte werden gesucht...",
    recipesFound: "Rezepte gefunden",
    noMatchingRecipe: "Keine passenden Rezepte gefunden",
    tryDifferentIngredients: "Probieren Sie andere Zutaten.",
    match: "Übereinstimmung",
    availableIngredients: "Zutaten vorhanden",
    missingIngredients: "Fehlende Zutaten:",
    addMissingToList: "Fehlende zur Liste hinzufügen",
    exactMatches: "Exakte Treffer",
    partialMatches: "Rezepte mit fehlenden Zutaten",
    aiIngredientHelp: "KI-Kochhinweis",
    aiIngredientResult: "KI-Kochhinweis",
    ingredientAiLocked: "KI-Vorschlag gesperrt",
    ingredientAiLockedHint: "Ohne Premium können Sie eine belohnte Anzeige ansehen und bis zu 3 KI-Vorschläge pro Tag erhalten.",
    ingredientAiRewardConfirm: "Sie sehen eine belohnte Anzeigen-Simulation, um 1 KI-Zutatenvorschlag zu erhalten. Fortfahren?",
    watchAdForAi: "Anzeige ansehen und KI-Vorschlag erhalten",
    continueWith: "Weiter mit",
    requestFailed: "Anfrage fehlgeschlagen",
    translationNeedsKey: "Für die vollständige Rezeptübersetzung ist ein API-Schlüssel erforderlich; Kategorien und Labels sind lokalisiert.",
    admin: "Admin",
    adminPanel: "Adminbereich",
    adminPanelIntro: "Prüfen Sie Benutzerrezepte, bevor sie veröffentlicht werden.",
    adminAccessRequired: "Admin-Anmeldung erforderlich",
    adminAccessHint: "Dieser Bereich öffnet sich nur für das Konto, das mit ADMIN_EMAIL übereinstimmt.",
    status: "Status",
    pending: "Ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    loadingRecipes: "Rezepte werden geladen...",
    noModerationRecipes: "Keine Rezepte zur Prüfung",
    noModerationRecipesHint: "In diesem Status gibt es keine Rezepte.",
    approve: "Genehmigen",
    reject: "Ablehnen",
    preview: "Vorschau",
    recipeApproved: "Rezept genehmigt",
    recipeRejected: "Rezept abgelehnt",
    recipePendingReview: "Rezept gespeichert und zur Admin-Prüfung gesendet.",
    emailAddress: "E-Mail-Adresse",
    displayName: "Anzeigename",
    recipeImage: "Rezeptbild",
    recipeImageHint: "JPG, PNG oder WEBP; max. 2 MB.",
    changeImage: "Bild ändern",
    recipeImageUpdated: "Rezeptbild aktualisiert",
    saveChanges: "Änderungen speichern",
    recipeContentUpdated: "Rezeptinhalt aktualisiert",
    recipeContentRequired: "Zutaten und Schritte dürfen nicht leer sein.",
    designSettings: "Design-Einstellungen",
    designSettingsIntro: "App-Titel, Schriftarten, Textgröße, Buttonfarben und Menü-Icons ändern.",
    appTitle: "App-Titel",
    bodyFont: "Textschrift",
    headingFont: "Überschriftenschrift",
    baseFontSize: "Grundschriftgröße",
    headingScale: "Überschriftenskalierung",
    buttonRadius: "Button-Eckenradius",
    primaryButtonColor: "Primäre Buttonfarbe",
    primaryButtonHover: "Primäre Hoverfarbe",
    successButtonColor: "Grüne Buttonfarbe",
    buttonTextColor: "Button-Textfarbe",
    saveDesignSettings: "Design speichern",
    designSettingsSaved: "Design-Einstellungen gespeichert"
  },
  it: {
    dailyIntro: "Where flavor meets wellness.",
    allMealsIntro: "Esplora ricette per pasto, cucina, categoria e calorie.",
    dessertsIntro: "Scopri dessert cremosi, alla frutta, fit e internazionali con calorie.",
    all: "Tutti",
    fitHealthy: "Fit / sano",
    allMealsFilter: "Tutti i pasti",
    allCuisines: "Tutte le cucine",
    allWorldCuisines: "Tutte le cucine del mondo",
    allDessertTypes: "Tutti i tipi di dessert",
    dessertType: "Tipo di dessert",
    newPlan: "Nuovo piano",
    loadingDaily: "Preparazione del piano giornaliero...",
    loadingMeals: "Caricamento piatti...",
    loadingDesserts: "Caricamento dessert...",
    totalDailyCalories: "Calorie totali stimate dei tre pasti principali di oggi",
    cachedPlan: "Il piano di oggi è stato caricato dalla cache.",
    noMealFound: "Nessun piatto trovato",
    noDessertFound: "Nessun dessert trovato",
    tryDifferentFilters: "Cambia i filtri e riprova.",
    mealsFound: "piatti trovati",
    dessertsFound: "dessert trovati",
    noSlotSuggestion: "Nessun suggerimento trovato per questi filtri.",
    searchMeals: "Cerca piatto, cucina o ingrediente...",
    searchDesserts: "Cerca dessert o ingrediente...",
    minutes: "min",
    kcal: "kcal",
    ingredientUnit: "ingredienti",
    addOwnRecipe: "Aggiungi la tua ricetta",
    addRecipeIntro: "Salva i tuoi piatti o dessert in pochi passaggi.",
    addRecipeLoginNote: "Devi accedere prima di aggiungere una ricetta.",
    recipeName: "Nome ricetta",
    mealType: "Pasto",
    calories: "Calorie",
    prepTime: "Preparazione",
    cookTime: "Cottura",
    prepMinutes: "Preparazione (min)",
    cookMinutes: "Cottura (min)",
    servings: "Porzioni",
    ingredients: "Ingredienti",
    steps: "Passaggi",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saving: "Salvataggio...",
    recipeSaved: "Ricetta salvata",
    ingredientsPlaceholder: "Scrivi un ingrediente per riga o separa con virgole",
    stepsPlaceholder: "Scrivi un passaggio per riga",
    recipeNamePlaceholder: "Esempio: Pasta alle verdure fatta in casa",
    rateRecipe: "Valuta questa ricetta",
    socialInfo: "La struttura di accesso social è pronta. Le chiavi OAuth reali possono essere collegate più tardi.",
    favoriteAdd: "Aggiungi ai preferiti",
    favoriteRemove: "Rimuovi dai preferiti",
    favoriteAdded: "Aggiunto ai preferiti",
    favoriteRemoved: "Rimosso dai preferiti",
    back: "Indietro",
    backToMeals: "Torna ai piatti",
    noMealSelected: "Nessun piatto selezionato",
    addAllIngredients: "Aggiungi ingredienti alla lista",
    addToList: "+ Lista",
    added: "Aggiunto",
    alreadyOnList: "Già nella lista",
    ingredientAdded: "aggiunto alla lista",
    ingredientsAddedToShopping: "ingredienti aggiunti alla lista della spesa",
    videoRecipe: "Video ricetta",
    rateLoginRequired: "Accedi per valutare.",
    ratingSaved: "Valutazione salvata",
    noRatingYet: "Ancora nessuna valutazione",
    dietitianIntro: "Brevi consigli pratici ogni giorno per alimentazione e stile di vita.",
    dailyNutritionAdvice: "Consiglio quotidiano su nutrizione e stile di vita",
    dailyTips: "Consigli del giorno",
    suggestedFoodToday: "Alimento consigliato oggi:",
    adviceLoading: "Preparazione del consiglio di oggi...",
    adviceLoadFailed: "Impossibile caricare il consiglio",
    checkBackendOrKey: "Controlla la connessione backend o la chiave API.",
    askDietitian: "Chiedi al dietista",
    medicalDisclaimer: "Questa sezione è informativa e non sostituisce diagnosi o trattamento.",
    askPlaceholder: "Esempio: Cosa posso scegliere per una cena più leggera?",
    answerPreparing: "Preparazione risposta...",
    cannotAnswerNow: "Non posso rispondere ora. Riprova tra poco.",
    wait: "Attendi",
    ask: "Chiedi",
    favoritesIntro: "Raggiungi rapidamente piatti e dessert che ti piacciono.",
    noFavorites: "Ancora nessuna ricetta preferita",
    favoriteHint: "Tocca il cuore sulle schede per aggiungere preferiti.",
    browseMeals: "Sfoglia piatti",
    favoriteRecipeCount: "ricette preferite",
    shoppingIntro: "Tieni traccia degli ingredienti mancanti aggiunti dalle ricette.",
    list: "Lista",
    waiting: "in attesa",
    completed: "completato",
    clearCompleted: "Cancella completati",
    emptyList: "La lista è vuota",
    shoppingEmptyHint: "Aggiungi ingredienti dalle pagine di dettaglio.",
    purchased: "Acquistati",
    addNewIngredient: "Aggiungi nuovo ingrediente...",
    add: "Aggiungi",
    delete: "Elimina",
    purchasedCleared: "Elementi acquistati cancellati",
    ingredientSuggest: "Suggerisci per ingredienti",
    ingredientSuggestIntro: "Inserisci ciò che hai e troveremo ricette adatte.",
    yourIngredients: "I tuoi ingredienti",
    addIngredientPlaceholder: "Aggiungi ingrediente (es. pomodoro, uovo...)",
    searching: "Ricerca...",
    findRecipe: "Trova ricette",
    clear: "Cancella",
    searchingRecipes: "Ricerca ricette...",
    recipesFound: "ricette trovate",
    noMatchingRecipe: "Nessuna ricetta corrispondente",
    tryDifferentIngredients: "Prova ingredienti diversi.",
    match: "Corrispondenza",
    availableIngredients: "ingredienti disponibili",
    missingIngredients: "Ingredienti mancanti:",
    addMissingToList: "Aggiungi mancanti alla lista",
    exactMatches: "Corrispondenze esatte",
    partialMatches: "Ricette con ingredienti mancanti",
    aiIngredientHelp: "Consiglio chef AI",
    aiIngredientResult: "Consiglio chef AI",
    ingredientAiLocked: "Suggerimento AI bloccato",
    ingredientAiLockedHint: "Senza premium puoi guardare un annuncio premiato per massimo 3 suggerimenti AI al giorno.",
    ingredientAiRewardConfirm: "Guarderai una simulazione di annuncio premiato per ottenere 1 suggerimento AI. Continuare?",
    watchAdForAi: "Guarda annuncio e ottieni suggerimento AI",
    continueWith: "Continua con",
    requestFailed: "Richiesta non riuscita",
    translationNeedsKey: "La traduzione completa richiede una chiave API; categorie ed etichette sono localizzate.",
    admin: "Admin",
    adminPanel: "Pannello admin",
    adminPanelIntro: "Controlla le ricette degli utenti prima della pubblicazione.",
    adminAccessRequired: "Accesso admin richiesto",
    adminAccessHint: "Questa sezione si apre solo per l'account che corrisponde ad ADMIN_EMAIL.",
    status: "Stato",
    pending: "In attesa",
    approved: "Approvata",
    rejected: "Rifiutata",
    loadingRecipes: "Caricamento ricette...",
    noModerationRecipes: "Nessuna ricetta da controllare",
    noModerationRecipesHint: "Non ci sono ricette in questo stato.",
    approve: "Approva",
    reject: "Rifiuta",
    preview: "Anteprima",
    recipeApproved: "Ricetta approvata",
    recipeRejected: "Ricetta rifiutata",
    recipePendingReview: "Ricetta salvata e inviata alla revisione admin.",
    emailAddress: "Indirizzo email",
    displayName: "Nome visualizzato",
    recipeImage: "Immagine ricetta",
    recipeImageHint: "JPG, PNG o WEBP; max 2 MB.",
    changeImage: "Cambia immagine",
    recipeImageUpdated: "Immagine ricetta aggiornata",
    saveChanges: "Salva modifiche",
    recipeContentUpdated: "Contenuto ricetta aggiornato",
    recipeContentRequired: "Ingredienti e passaggi non possono essere vuoti.",
    designSettings: "Impostazioni design",
    designSettingsIntro: "Modifica titolo app, font, dimensione testo, colori dei pulsanti e icone menu.",
    appTitle: "Titolo app",
    bodyFont: "Font testo",
    headingFont: "Font titoli",
    baseFontSize: "Dimensione testo base",
    headingScale: "Scala titoli",
    buttonRadius: "Raggio angoli pulsanti",
    primaryButtonColor: "Colore pulsante principale",
    primaryButtonHover: "Colore hover principale",
    successButtonColor: "Colore pulsante verde",
    buttonTextColor: "Colore testo pulsanti",
    saveDesignSettings: "Salva design",
    designSettingsSaved: "Impostazioni design salvate"
  }
};

Object.assign(EXTRA_TRANSLATIONS, {
  pt: {
    dailyIntro: "Where flavor meets wellness.",
    allMealsIntro: "Explore receitas por refeição, cozinha, categoria e calorias.",
    dessertsIntro: "Descubra sobremesas cremosas, frutadas, fit e internacionais com calorias.",
    all: "Todos",
    fitHealthy: "Fit / saudável",
    allMealsFilter: "Todas as refeições",
    allCuisines: "Todas as cozinhas",
    allWorldCuisines: "Todas as cozinhas do mundo",
    allDessertTypes: "Todos os tipos de sobremesa",
    dessertType: "Tipo de sobremesa",
    newPlan: "Novo plano",
    loadingDaily: "Preparando plano diário...",
    loadingMeals: "Carregando pratos...",
    loadingDesserts: "Carregando sobremesas...",
    totalDailyCalories: "Calorias totais estimadas das três refeições principais de hoje",
    cachedPlan: "O plano de hoje foi carregado do cache.",
    noMealFound: "Nenhum prato encontrado",
    noDessertFound: "Nenhuma sobremesa encontrada",
    tryDifferentFilters: "Altere os filtros e tente novamente.",
    mealsFound: "pratos encontrados",
    dessertsFound: "sobremesas encontradas",
    noSlotSuggestion: "Nenhuma sugestão encontrada para estes filtros.",
    searchMeals: "Buscar prato, cozinha ou ingrediente...",
    searchDesserts: "Buscar sobremesa ou ingrediente...",
    minutes: "min",
    kcal: "kcal",
    ingredientUnit: "ingredientes",
    addOwnRecipe: "Adicionar sua receita",
    addRecipeIntro: "Salve seus pratos ou sobremesas em poucos passos.",
    addRecipeLoginNote: "Você precisa entrar antes de adicionar uma receita.",
    recipeName: "Nome da receita",
    mealType: "Refeição",
    calories: "Calorias",
    prepTime: "Preparo",
    cookTime: "Cozimento",
    prepMinutes: "Preparo (min)",
    cookMinutes: "Cozimento (min)",
    servings: "Porções",
    ingredients: "Ingredientes",
    steps: "Etapas",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saving: "Salvando...",
    recipeSaved: "Receita salva",
    ingredientsPlaceholder: "Escreva um ingrediente por linha ou separe por vírgulas",
    stepsPlaceholder: "Escreva uma etapa por linha",
    recipeNamePlaceholder: "Exemplo: Massa caseira com legumes",
    rateRecipe: "Avaliar esta receita",
    socialInfo: "A estrutura de login social está pronta. Chaves OAuth reais podem ser conectadas depois.",
    favoriteAdd: "Adicionar aos favoritos",
    favoriteRemove: "Remover dos favoritos",
    favoriteAdded: "Adicionado aos favoritos",
    favoriteRemoved: "Removido dos favoritos",
    back: "Voltar",
    backToMeals: "Voltar aos pratos",
    noMealSelected: "Nenhum prato selecionado",
    addAllIngredients: "Adicionar ingredientes à lista",
    addToList: "+ Lista",
    added: "Adicionado",
    alreadyOnList: "Já está na lista",
    ingredientAdded: "adicionado à lista",
    ingredientsAddedToShopping: "ingredientes adicionados à lista de compras",
    videoRecipe: "Receita em vídeo",
    rateLoginRequired: "Entre para avaliar.",
    ratingSaved: "Avaliação salva",
    noRatingYet: "Ainda sem avaliações",
    dietitianIntro: "Dicas curtas e práticas de nutrição e estilo de vida todos os dias.",
    dailyNutritionAdvice: "Conselho diário de nutrição e estilo de vida",
    dailyTips: "Dicas de hoje",
    suggestedFoodToday: "Alimento sugerido hoje:",
    adviceLoading: "Preparando o conselho de hoje...",
    adviceLoadFailed: "Não foi possível carregar o conselho",
    checkBackendOrKey: "Verifique a conexão com o backend ou a chave API.",
    askDietitian: "Perguntar ao nutricionista",
    medicalDisclaimer: "Esta seção é informativa e não substitui diagnóstico ou tratamento.",
    askPlaceholder: "Exemplo: O que posso escolher para um jantar mais leve?",
    answerPreparing: "Preparando resposta...",
    cannotAnswerNow: "Não consigo responder agora. Tente novamente em breve.",
    wait: "Aguarde",
    ask: "Perguntar",
    favoritesIntro: "Acesse rapidamente pratos e sobremesas favoritos.",
    noFavorites: "Ainda não há receitas favoritas",
    favoriteHint: "Toque no coração dos cartões para salvar favoritos.",
    browseMeals: "Ver pratos",
    favoriteRecipeCount: "receitas favoritas",
    shoppingIntro: "Acompanhe ingredientes faltantes adicionados das receitas.",
    list: "Lista",
    waiting: "pendente",
    completed: "concluído",
    clearCompleted: "Limpar concluídos",
    emptyList: "A lista está vazia",
    shoppingEmptyHint: "Adicione ingredientes nas páginas de detalhes.",
    purchased: "Comprado",
    addNewIngredient: "Adicionar novo ingrediente...",
    add: "Adicionar",
    delete: "Excluir",
    purchasedCleared: "Itens comprados limpos",
    ingredientSuggest: "Sugerir por ingredientes",
    ingredientSuggestIntro: "Informe o que você tem e encontraremos receitas adequadas.",
    yourIngredients: "Seus ingredientes",
    addIngredientPlaceholder: "Adicionar ingrediente (ex.: tomate, ovo...)",
    searching: "Buscando...",
    findRecipe: "Encontrar receitas",
    clear: "Limpar",
    searchingRecipes: "Buscando receitas...",
    recipesFound: "receitas encontradas",
    noMatchingRecipe: "Nenhuma receita correspondente",
    tryDifferentIngredients: "Tente ingredientes diferentes.",
    match: "Correspondência",
    availableIngredients: "ingredientes disponíveis",
    missingIngredients: "Ingredientes faltantes:",
    addMissingToList: "Adicionar faltantes à lista",
    exactMatches: "Correspondências exatas",
    partialMatches: "Receitas com ingredientes faltantes",
    aiIngredientHelp: "Comentário do chef IA",
    aiIngredientResult: "Comentário do chef IA",
    ingredientAiLocked: "Sugestão IA bloqueada",
    ingredientAiLockedHint: "Sem premium, você pode assistir a um anúncio recompensado para até 3 sugestões IA por dia.",
    ingredientAiRewardConfirm: "Você assistirá a uma simulação de anúncio recompensado para ganhar 1 sugestão IA. Continuar?",
    watchAdForAi: "Assistir anúncio e receber sugestão IA",
    continueWith: "Continuar com",
    requestFailed: "Falha na solicitação",
    translationNeedsKey: "A tradução completa da receita requer uma chave API; categorias e rótulos estão localizados.",
    admin: "Admin",
    adminPanel: "Painel admin",
    adminPanelIntro: "Revise receitas de usuários antes da publicação.",
    adminAccessRequired: "Login admin necessário",
    adminAccessHint: "Esta seção abre apenas para a conta que corresponde a ADMIN_EMAIL.",
    status: "Status",
    pending: "Pendente",
    approved: "Aprovada",
    rejected: "Rejeitada",
    loadingRecipes: "Carregando receitas...",
    noModerationRecipes: "Nenhuma receita para revisar",
    noModerationRecipesHint: "Não há receitas neste status.",
    approve: "Aprovar",
    reject: "Rejeitar",
    preview: "Prévia",
    recipeApproved: "Receita aprovada",
    recipeRejected: "Receita rejeitada",
    recipePendingReview: "Receita salva e enviada para revisão admin.",
    emailAddress: "Endereço de e-mail",
    displayName: "Nome exibido",
    recipeImage: "Imagem da receita",
    recipeImageHint: "JPG, PNG ou WEBP; máx. 2 MB.",
    changeImage: "Alterar imagem",
    recipeImageUpdated: "Imagem da receita atualizada",
    saveChanges: "Salvar alterações",
    recipeContentUpdated: "Conteúdo da receita atualizado",
    recipeContentRequired: "Ingredientes e etapas não podem ficar vazios."
  },
  es: {
    dailyIntro: "Where flavor meets wellness.",
    allMealsIntro: "Explora recetas por comida, cocina, categoría y calorías.",
    dessertsIntro: "Descubre postres cremosos, frutales, fit e internacionales con calorías.",
    all: "Todos",
    fitHealthy: "Fit / saludable",
    allMealsFilter: "Todas las comidas",
    allCuisines: "Todas las cocinas",
    allWorldCuisines: "Todas las cocinas del mundo",
    allDessertTypes: "Todos los tipos de postre",
    dessertType: "Tipo de postre",
    newPlan: "Nuevo plan",
    loadingDaily: "Preparando plan diario...",
    loadingMeals: "Cargando comidas...",
    loadingDesserts: "Cargando postres...",
    totalDailyCalories: "Calorías totales estimadas de las tres comidas principales de hoy",
    cachedPlan: "El plan de hoy se cargó desde la caché.",
    noMealFound: "No se encontró comida",
    noDessertFound: "No se encontró postre",
    tryDifferentFilters: "Cambia los filtros e inténtalo de nuevo.",
    mealsFound: "comidas encontradas",
    dessertsFound: "postres encontrados",
    noSlotSuggestion: "No se encontró sugerencia para estos filtros.",
    searchMeals: "Buscar comida, cocina o ingrediente...",
    searchDesserts: "Buscar postre o ingrediente...",
    minutes: "min",
    kcal: "kcal",
    ingredientUnit: "ingredientes",
    addOwnRecipe: "Añade tu receta",
    addRecipeIntro: "Guarda tus comidas o postres en pocos pasos.",
    addRecipeLoginNote: "Debes iniciar sesión antes de añadir una receta.",
    recipeName: "Nombre de la receta",
    mealType: "Comida",
    calories: "Calorías",
    prepTime: "Preparación",
    cookTime: "Cocción",
    prepMinutes: "Preparación (min)",
    cookMinutes: "Cocción (min)",
    servings: "Porciones",
    ingredients: "Ingredientes",
    steps: "Pasos",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saving: "Guardando...",
    recipeSaved: "Receta guardada",
    ingredientsPlaceholder: "Escribe un ingrediente por línea o sepáralos con comas",
    stepsPlaceholder: "Escribe un paso por línea",
    recipeNamePlaceholder: "Ejemplo: Pasta casera con verduras",
    rateRecipe: "Valorar esta receta",
    socialInfo: "La estructura de inicio social está lista. Las claves OAuth reales pueden conectarse después.",
    favoriteAdd: "Añadir a favoritos",
    favoriteRemove: "Quitar de favoritos",
    favoriteAdded: "Añadido a favoritos",
    favoriteRemoved: "Quitado de favoritos",
    back: "Atrás",
    backToMeals: "Volver a comidas",
    noMealSelected: "No se seleccionó comida",
    addAllIngredients: "Añadir ingredientes a la lista",
    addToList: "+ Lista",
    added: "Añadido",
    alreadyOnList: "Ya está en la lista",
    ingredientAdded: "añadido a la lista",
    ingredientsAddedToShopping: "ingredientes añadidos a la lista de compras",
    videoRecipe: "Receta en video",
    rateLoginRequired: "Inicia sesión para valorar.",
    ratingSaved: "Valoración guardada",
    noRatingYet: "Aún no hay valoraciones",
    dietitianIntro: "Consejos breves y prácticos de nutrición y estilo de vida cada día.",
    dailyNutritionAdvice: "Consejo diario de nutrición y estilo de vida",
    dailyTips: "Consejos de hoy",
    suggestedFoodToday: "Alimento sugerido hoy:",
    adviceLoading: "Preparando el consejo de hoy...",
    adviceLoadFailed: "No se pudo cargar el consejo",
    checkBackendOrKey: "Comprueba la conexión del backend o la clave API.",
    askDietitian: "Preguntar al dietista",
    medicalDisclaimer: "Esta sección es informativa y no sustituye diagnóstico ni tratamiento.",
    askPlaceholder: "Ejemplo: ¿Qué puedo elegir para una cena más ligera?",
    answerPreparing: "Preparando respuesta...",
    cannotAnswerNow: "No puedo responder ahora. Inténtalo de nuevo pronto.",
    wait: "Espera",
    ask: "Preguntar",
    favoritesIntro: "Accede rápidamente a comidas y postres que te gustaron.",
    noFavorites: "Aún no hay recetas favoritas",
    favoriteHint: "Toca el corazón en las tarjetas para guardar favoritos.",
    browseMeals: "Ver comidas",
    favoriteRecipeCount: "recetas favoritas",
    shoppingIntro: "Controla ingredientes faltantes añadidos desde recetas.",
    list: "Lista",
    waiting: "pendiente",
    completed: "completado",
    clearCompleted: "Borrar completados",
    emptyList: "La lista está vacía",
    shoppingEmptyHint: "Añade ingredientes desde las páginas de detalle.",
    purchased: "Comprado",
    addNewIngredient: "Añadir nuevo ingrediente...",
    add: "Añadir",
    delete: "Eliminar",
    purchasedCleared: "Artículos comprados borrados",
    ingredientSuggest: "Sugerir por ingredientes",
    ingredientSuggestIntro: "Ingresa lo que tienes y encontraremos recetas adecuadas.",
    yourIngredients: "Tus ingredientes",
    addIngredientPlaceholder: "Añadir ingrediente (ej.: tomate, huevo...)",
    searching: "Buscando...",
    findRecipe: "Encontrar recetas",
    clear: "Limpiar",
    searchingRecipes: "Buscando recetas...",
    recipesFound: "recetas encontradas",
    noMatchingRecipe: "No se encontraron recetas coincidentes",
    tryDifferentIngredients: "Prueba ingredientes diferentes.",
    match: "Coincidencia",
    availableIngredients: "ingredientes disponibles",
    missingIngredients: "Ingredientes faltantes:",
    addMissingToList: "Añadir faltantes a la lista",
    exactMatches: "Coincidencias exactas",
    partialMatches: "Recetas con ingredientes faltantes",
    aiIngredientHelp: "Comentario del chef IA",
    aiIngredientResult: "Comentario del chef IA",
    ingredientAiLocked: "Sugerencia IA bloqueada",
    ingredientAiLockedHint: "Sin premium, puedes ver un anuncio recompensado para hasta 3 sugerencias IA al día.",
    ingredientAiRewardConfirm: "Verás una simulación de anuncio recompensado para obtener 1 sugerencia IA. ¿Continuar?",
    watchAdForAi: "Ver anuncio y recibir sugerencia IA",
    continueWith: "Continuar con",
    requestFailed: "Solicitud fallida",
    translationNeedsKey: "La traducción completa requiere una clave API; categorías y etiquetas están localizadas.",
    admin: "Admin",
    adminPanel: "Panel admin",
    adminPanelIntro: "Revisa recetas de usuarios antes de publicarlas.",
    adminAccessRequired: "Inicio admin requerido",
    adminAccessHint: "Esta sección solo se abre para la cuenta que coincide con ADMIN_EMAIL.",
    status: "Estado",
    pending: "Pendiente",
    approved: "Aprobada",
    rejected: "Rechazada",
    loadingRecipes: "Cargando recetas...",
    noModerationRecipes: "No hay recetas para revisar",
    noModerationRecipesHint: "No hay recetas en este estado.",
    approve: "Aprobar",
    reject: "Rechazar",
    preview: "Vista previa",
    recipeApproved: "Receta aprobada",
    recipeRejected: "Receta rechazada",
    recipePendingReview: "Receta guardada y enviada a revisión admin.",
    emailAddress: "Correo electrónico",
    displayName: "Nombre visible",
    recipeImage: "Imagen de receta",
    recipeImageHint: "JPG, PNG o WEBP; máx. 2 MB.",
    changeImage: "Cambiar imagen",
    recipeImageUpdated: "Imagen actualizada",
    saveChanges: "Guardar cambios",
    recipeContentUpdated: "Contenido de receta actualizado",
    recipeContentRequired: "Ingredientes y pasos no pueden estar vacíos."
  }
});

Object.assign(EXTRA_TRANSLATIONS, {
  fr: {
    dailyIntro: "Where flavor meets wellness.",
    allMealsIntro: "Explorez les recettes par repas, cuisine, catégorie et calories.",
    dessertsIntro: "Découvrez des desserts crémeux, fruités, légers et internationaux avec leurs calories.",
    all: "Tous",
    fitHealthy: "Fit / sain",
    allMealsFilter: "Tous les repas",
    allCuisines: "Toutes les cuisines",
    allWorldCuisines: "Toutes les cuisines du monde",
    allDessertTypes: "Tous les types de desserts",
    dessertType: "Type de dessert",
    newPlan: "Nouveau plan",
    loadingDaily: "Préparation du plan du jour...",
    loadingMeals: "Chargement des plats...",
    loadingDesserts: "Chargement des desserts...",
    totalDailyCalories: "Calories totales estimées pour les trois repas principaux d'aujourd'hui",
    cachedPlan: "Le plan du jour a été chargé depuis l'enregistrement.",
    noMealFound: "Aucun plat trouvé",
    noDessertFound: "Aucun dessert trouvé",
    tryDifferentFilters: "Modifiez les filtres et réessayez.",
    mealsFound: "plats trouvés",
    dessertsFound: "desserts trouvés",
    noSlotSuggestion: "Aucune suggestion trouvée pour ces filtres.",
    searchMeals: "Rechercher un plat, une cuisine ou un ingrédient...",
    searchDesserts: "Rechercher un dessert ou un ingrédient...",
    minutes: "min",
    kcal: "kcal",
    ingredientUnit: "ingrédients",
    addOwnRecipe: "Ajouter votre recette",
    addRecipeIntro: "Enregistrez facilement vos plats ou desserts.",
    addRecipeLoginNote: "Vous devez vous connecter avec un compte social pour ajouter une recette.",
    recipeName: "Nom de la recette",
    mealType: "Repas",
    calories: "Calories",
    prepTime: "Préparation",
    cookTime: "Cuisson",
    prepMinutes: "Préparation (min)",
    cookMinutes: "Cuisson (min)",
    servings: "Portions",
    ingredients: "Ingrédients",
    steps: "Étapes",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saving: "Enregistrement...",
    recipeSaved: "Recette enregistrée",
    ingredientsPlaceholder: "Écrivez un ingrédient par ligne ou séparez-les par des virgules",
    stepsPlaceholder: "Écrivez une étape par ligne",
    recipeNamePlaceholder: "Exemple : pâtes aux légumes maison",
    rateRecipe: "Noter cette recette",
    socialInfo: "La connexion sociale est prête. Les vraies clés OAuth pourront être reliées plus tard.",
    favoriteAdd: "Ajouter aux favoris",
    favoriteRemove: "Retirer des favoris",
    favoriteAdded: "Ajouté aux favoris",
    favoriteRemoved: "Retiré des favoris",
    back: "Retour",
    backToMeals: "Retour aux plats",
    noMealSelected: "Aucun plat sélectionné",
    addAllIngredients: "Ajouter les ingrédients à la liste",
    addToList: "+ Liste",
    added: "Ajouté",
    alreadyOnList: "Déjà dans la liste",
    ingredientAdded: "ajouté à la liste",
    ingredientsAddedToShopping: "ingrédients ajoutés à la liste de courses",
    videoRecipe: "Recette vidéo",
    rateLoginRequired: "Connectez-vous pour noter.",
    ratingSaved: "Note enregistrée",
    noRatingYet: "Aucune note pour l'instant",
    dietitianIntro: "Conseils courts et pratiques chaque jour pour la nutrition et le mode de vie.",
    dailyNutritionAdvice: "Conseil nutrition et mode de vie du jour",
    dailyTips: "Conseils du jour",
    suggestedFoodToday: "Aliment suggéré aujourd'hui :",
    adviceLoading: "Préparation du conseil du jour...",
    adviceLoadFailed: "Le conseil n'a pas pu être chargé",
    checkBackendOrKey: "Vérifiez la connexion backend ou la clé API.",
    askDietitian: "Demander au diététicien",
    medicalDisclaimer: "Cette section fournit des informations générales et ne remplace pas un diagnostic ou un traitement personnel.",
    askPlaceholder: "Exemple : que choisir pour un dîner plus léger ?",
    answerPreparing: "Préparation de la réponse...",
    cannotAnswerNow: "Je ne peux pas répondre pour le moment. Veuillez réessayer plus tard.",
    wait: "Patienter",
    ask: "Demander",
    favoritesIntro: "Retrouvez rapidement les plats et desserts que vous aimez.",
    noFavorites: "Aucune recette favorite pour l'instant",
    favoriteHint: "Touchez le coeur sur les cartes de recettes pour les ajouter aux favoris.",
    browseMeals: "Parcourir les plats",
    favoriteRecipeCount: "recettes favorites",
    shoppingIntro: "Suivez les ingrédients manquants ajoutés depuis les recettes.",
    list: "Liste",
    waiting: "en attente",
    completed: "terminé",
    clearCompleted: "Supprimer les éléments terminés",
    emptyList: "La liste est vide",
    shoppingEmptyHint: "Ajoutez des ingrédients depuis les détails des recettes.",
    purchased: "Achetés",
    addNewIngredient: "Ajouter un ingrédient...",
    add: "Ajouter",
    delete: "Supprimer",
    purchasedCleared: "Éléments achetés supprimés",
    ingredientSuggest: "Suggestion par ingrédients",
    ingredientSuggestIntro: "Saisissez ce que vous avez, nous trouverons des recettes adaptées.",
    yourIngredients: "Vos ingrédients",
    addIngredientPlaceholder: "Ajouter un ingrédient (ex. tomate, oeuf...)",
    searching: "Recherche...",
    findRecipe: "Trouver des recettes",
    clear: "Effacer",
    searchingRecipes: "Recherche de recettes...",
    recipesFound: "recettes trouvées",
    noMatchingRecipe: "Aucune recette correspondante",
    tryDifferentIngredients: "Essayez d'autres ingrédients.",
    match: "Correspondance",
    availableIngredients: "ingrédients disponibles",
    missingIngredients: "Ingrédients manquants :",
    addMissingToList: "Ajouter les manquants à la liste",
    exactMatches: "Correspondances exactes",
    partialMatches: "Recettes avec ingrédients manquants",
    aiIngredientHelp: "Conseil chef IA",
    aiIngredientResult: "Conseil chef IA",
    ingredientAiLocked: "Suggestion IA verrouillée",
    ingredientAiLockedHint: "Sans premium, vous pouvez regarder une publicité récompensée pour obtenir jusqu'à 3 suggestions IA par jour.",
    ingredientAiRewardConfirm: "Vous allez regarder une simulation de publicité récompensée pour obtenir 1 suggestion IA. Continuer ?",
    watchAdForAi: "Regarder une pub et obtenir une suggestion IA",
    continueWith: "Continuer avec",
    requestFailed: "La requête a échoué",
    translationNeedsKey: "La traduction complète des recettes nécessite GROQ_API_KEY ; catégories et étiquettes sont localisées.",
    admin: "Admin",
    adminPanel: "Panneau admin",
    adminPanelIntro: "Examinez les recettes des utilisateurs avant publication.",
    adminAccessRequired: "Connexion admin requise",
    adminAccessHint: "Cette section s'ouvre uniquement pour le compte correspondant à ADMIN_EMAIL.",
    status: "Statut",
    pending: "En attente",
    approved: "Approuvé",
    rejected: "Rejeté",
    loadingRecipes: "Chargement des recettes...",
    noModerationRecipes: "Aucune recette à examiner",
    noModerationRecipesHint: "Aucune recette dans ce statut.",
    approve: "Approuver",
    reject: "Rejeter",
    preview: "Aperçu",
    recipeApproved: "Recette approuvée",
    recipeRejected: "Recette rejetée",
    recipePendingReview: "Recette enregistrée et envoyée à l'admin pour validation.",
    emailAddress: "Adresse e-mail",
    displayName: "Nom affiché",
    recipeImage: "Image de recette",
    recipeImageHint: "JPG, PNG ou WEBP ; maximum 2 Mo.",
    changeImage: "Changer l'image",
    recipeImageUpdated: "Image de recette mise à jour",
    saveChanges: "Enregistrer les modifications",
    recipeContentUpdated: "Contenu de la recette mis à jour",
    recipeContentRequired: "Les ingrédients et les étapes ne peuvent pas être vides.",
    designSettings: "Paramètres de design",
    designSettingsIntro: "Modifiez le titre de l'application, les polices, la taille du texte, les couleurs des boutons et les icônes du menu.",
    interstitialAdMessage: "Simulation de publicité interstitielle. Dans la vraie version mobile, une courte publicité de transition sera affichée ici.",
    appTitle: "Titre de l'application",
    bodyFont: "Police générale",
    headingFont: "Police des titres",
    baseFontSize: "Taille de texte générale",
    headingScale: "Échelle des titres",
    buttonRadius: "Arrondi des boutons",
    primaryButtonColor: "Couleur du bouton principal",
    primaryButtonHover: "Couleur au survol du bouton principal",
    successButtonColor: "Couleur du bouton vert",
    buttonTextColor: "Couleur du texte des boutons",
    saveDesignSettings: "Enregistrer le design",
    designSettingsSaved: "Paramètres de design enregistrés",
    myProfile: "Mon profil",
    profileIntro: "Enregistrez votre taille, votre poids et vos antécédents de santé ; votre fourchette de poids sain sera calculée et le diététicien pourra en tenir compte.",
    profileLoginRequired: "Connectez-vous pour votre profil",
    profileLoginHint: "La taille, le poids et les données de santé sont enregistrés uniquement dans le compte connecté.",
    heightCm: "Taille (cm)",
    weightKg: "Poids (kg)",
    pastIllnesses: "Maladies passées",
    pastIllnessesPlaceholder: "Ex. opération, infection grave, problème de santé important",
    chronicDiseases: "Maladies chroniques",
    chronicDiseasesPlaceholder: "Ex. diabète, hypertension, thyroïde, maladie coeliaque",
    allergies: "Allergies / intolérances",
    allergiesPlaceholder: "Ex. allergie aux arachides, intolérance au lactose, sensibilité au gluten",
    medications: "Médicaments / compléments réguliers",
    medicationsPlaceholder: "Ex. médicaments ou compléments utilisés avec suivi professionnel",
    healthProfilePrivacyNote: "Ces informations servent uniquement de court contexte pour des conseils généraux plus prudents ; elles ne remplacent pas un diagnostic ou un traitement.",
    saveProfile: "Enregistrer le profil",
    profileSaved: "Profil enregistré",
    idealWeightResult: "Calcul du poids sain",
    idealWeightRange: "Fourchette de poids sain",
    bmi: "IMC",
    bmiCategory: "Statut IMC",
    neutralTarget: "Objectif moyen",
    underweight: "Insuffisance pondérale",
    overweight: "Surpoids",
    obese: "Obésité",
    enterHeightWeight: "Saisissez taille et poids",
    enterHeightWeightHint: "Les deux valeurs sont nécessaires pour le calcul.",
    profileDietitianNote: "Lorsque vous posez une question, le diététicien utilise ce court résumé sans modifier les contrôles de coût.",
    profileLinkedToDietitian: "Votre profil est relié au diététicien",
    medicalProfileLinked: "profil médical enregistré",
    profileNotCompleted: "Profil incomplet",
    profileNotCompletedHint: "Ajoutez votre taille et votre poids pour des conseils plus personnalisés.",
    weeklyProgress: "Progression hebdomadaire",
    weeklyProgressIntro: "Enregistrez chaque semaine taille et poids ; suivez l'évolution avec graphiques et avis IA.",
    weekStart: "Début de semaine",
    saveWeeklyMeasurement: "Enregistrer la mesure hebdomadaire",
    weeklyMeasurementSaved: "Mesure hebdomadaire enregistrée",
    noWeeklyData: "Aucune donnée hebdomadaire",
    noWeeklyDataHint: "Enregistrez votre première mesure pour créer le graphique.",
    getWeeklyAiReview: "Obtenir l'avis IA hebdomadaire",
    aiWeeklyReview: "Avis IA hebdomadaire",
    weeklyReviewCached: "L'avis de cette semaine vient du cache",
    weeklyReviewGenerated: "L'avis de cette semaine a été généré",
    weeklyMeasurements: "Mesures hebdomadaires",
    weeklyProgressReport: "Rapport de progression hebdomadaire",
    generatedAt: "Généré le",
    recommendations: "Recommandations",
    focusNextWeek: "Objectif de la semaine prochaine",
    downloadPdf: "Télécharger le PDF",
    recipeDetailRewardConfirm: "Vos 2 ouvertures gratuites de détails de recette du jour sont utilisées. Regarder une publicité récompensée pour ouvrir cette recette ?",
    markMealEaten: "J'ai préparé / mangé ce plat",
    mealLoggedToday: "Marqué comme mangé aujourd'hui",
    mealLogHint: "Cela aide le diététicien à mieux comprendre vos habitudes alimentaires récentes.",
    iAteThis: "Je l'ai mangé",
    undoMealLog: "Annuler",
    mealLogged: "Enregistré dans votre journal alimentaire",
    mealLogRemoved: "Retiré de votre journal alimentaire",
    mealLogLoginRequired: "Connectez-vous pour enregistrer les plats mangés.",
    nutrition: "Valeurs nutritionnelles",
    nutritionIntro: "Consultez calories, macros, minéraux, vitamines et pourcentages des apports quotidiens pour 100 grammes.",
    nutritionSearchPlaceholder: "Exemple : oeuf, yaourt, avocat...",
    searchNutrition: "Rechercher un aliment",
    refreshFromSources: "Actualiser depuis les sources",
    nutritionLoading: "Recherche des données nutritionnelles...",
    nutritionPer100g: "Valeurs pour 100 grammes",
    nutritionConfidenceHigh: "Confiance élevée",
    nutritionConfidenceMedium: "Confiance moyenne",
    nutritionConfidenceLow: "Confiance faible",
    viewSource: "Ouvrir la source",
    vitaminsMinerals: "Vitamines et minéraux",
    dailyValueChart: "Couverture des apports quotidiens",
    macroDistribution: "Répartition des macros",
    nutritionNotFound: "Aucune donnée nutritionnelle trouvée",
    nutritionNotFoundHint: "Essayez un autre nom ou un aliment plus général."
  }
});

Object.assign(EXTRA_TRANSLATIONS, {
  de: {
    ...EXTRA_TRANSLATIONS.de,
    myProfile: "Mein Profil",
    profileIntro: "Speichere Größe und Gewicht; der gesunde Gewichtsbereich wird berechnet und die Online-Ernährungsberatung kann ihn berücksichtigen.",
    profileLoginRequired: "Für das Profil anmelden",
    profileLoginHint: "Größe und Gewicht werden nur im angemeldeten Konto gespeichert.",
    heightCm: "Größe (cm)",
    weightKg: "Gewicht (kg)",
    saveProfile: "Profil speichern",
    profileSaved: "Profil gespeichert",
    idealWeightResult: "Berechnung des gesunden Gewichts",
    idealWeightRange: "Gesunder Gewichtsbereich",
    bmi: "BMI",
    bmiCategory: "BMI-Status",
    neutralTarget: "Mittleres Ziel",
    underweight: "Untergewicht",
    overweight: "Übergewicht",
    obese: "Adipositasbereich",
    enterHeightWeight: "Größe und Gewicht eingeben",
    enterHeightWeightHint: "Für die Berechnung werden beide Werte benötigt.",
    profileDietitianNote: "Bei Fragen nutzt die Online-Ernährungsberatung diese kurze Profilzusammenfassung, ohne die Kostenkontrollen zu ändern.",
    profileLinkedToDietitian: "Dein Profil ist mit der Ernährungsberatung verbunden",
    profileNotCompleted: "Profil unvollständig",
    profileNotCompletedHint: "Ergänze Größe und Gewicht im Profil für persönlichere Hinweise.",
    nutrition: "Nährwerte",
    nutritionIntro: "Prüfe Kalorien, Makros, Mineralstoffe, Vitamine und Tageswerte pro 100 Gramm.",
    nutritionSearchPlaceholder: "Beispiel: Ei, Joghurt, Avocado...",
    searchNutrition: "Nährwerte suchen",
    refreshFromSources: "Aus Quellen aktualisieren",
    nutritionLoading: "Nährwerte werden gesucht...",
    nutritionPer100g: "Werte pro 100 Gramm",
    nutritionConfidenceHigh: "Hohe Sicherheit",
    nutritionConfidenceMedium: "Mittlere Sicherheit",
    nutritionConfidenceLow: "Niedrige Sicherheit",
    viewSource: "Quelle öffnen",
    vitaminsMinerals: "Vitamine und Mineralstoffe",
    dailyValueChart: "Deckung des Tagesbedarfs",
    macroDistribution: "Makroverteilung",
    nutritionNotFound: "Keine Nährwerte gefunden",
    nutritionNotFoundHint: "Versuche einen anderen oder allgemeineren Lebensmittelnamen."
  },
  it: {
    ...EXTRA_TRANSLATIONS.it,
    myProfile: "Il mio profilo",
    profileIntro: "Salva altezza e peso; calcoliamo il tuo intervallo di peso sano e il dietista online può usarlo.",
    profileLoginRequired: "Accedi per il profilo",
    profileLoginHint: "Altezza e peso vengono salvati solo negli account con accesso.",
    heightCm: "Altezza (cm)",
    weightKg: "Peso (kg)",
    saveProfile: "Salva profilo",
    profileSaved: "Profilo salvato",
    idealWeightResult: "Calcolo del peso sano",
    idealWeightRange: "Intervallo di peso sano",
    bmi: "BMI",
    bmiCategory: "Stato BMI",
    neutralTarget: "Obiettivo medio",
    underweight: "Sottopeso",
    overweight: "Sovrappeso",
    obese: "Fascia obesità",
    enterHeightWeight: "Inserisci altezza e peso",
    enterHeightWeightHint: "Entrambi i valori sono necessari per il calcolo.",
    profileDietitianNote: "Quando fai una domanda, il dietista online usa questo breve riepilogo senza modificare i controlli dei costi.",
    profileLinkedToDietitian: "Il profilo è collegato al dietista",
    profileNotCompleted: "Profilo incompleto",
    profileNotCompletedHint: "Aggiungi altezza e peso nel profilo per consigli più personali.",
    nutrition: "Valori nutrizionali",
    nutritionIntro: "Consulta calorie, macro, minerali, vitamine e percentuali giornaliere per 100 grammi.",
    nutritionSearchPlaceholder: "Esempio: uovo, yogurt, avocado...",
    searchNutrition: "Cerca nutrienti",
    refreshFromSources: "Aggiorna dalle fonti",
    nutritionLoading: "Ricerca dei valori nutrizionali...",
    nutritionPer100g: "Valori per 100 grammi",
    nutritionConfidenceHigh: "Alta affidabilità",
    nutritionConfidenceMedium: "Affidabilità media",
    nutritionConfidenceLow: "Bassa affidabilità",
    viewSource: "Apri fonte",
    vitaminsMinerals: "Vitamine e minerali",
    dailyValueChart: "Copertura del fabbisogno giornaliero",
    macroDistribution: "Distribuzione macro",
    nutritionNotFound: "Nessun valore nutrizionale trovato",
    nutritionNotFoundHint: "Prova un nome di alimento diverso o più generico."
  },
  pt: {
    ...EXTRA_TRANSLATIONS.pt,
    myProfile: "Meu perfil",
    profileIntro: "Salve altura e peso; calculamos sua faixa de peso saudável e o nutricionista online pode usá-la.",
    profileLoginRequired: "Entre para acessar o perfil",
    profileLoginHint: "Altura e peso são salvos apenas em contas conectadas.",
    heightCm: "Altura (cm)",
    weightKg: "Peso (kg)",
    saveProfile: "Salvar perfil",
    profileSaved: "Perfil salvo",
    idealWeightResult: "Cálculo de peso saudável",
    idealWeightRange: "Faixa de peso saudável",
    bmi: "IMC",
    bmiCategory: "Status do IMC",
    neutralTarget: "Meta média",
    underweight: "Abaixo do peso",
    overweight: "Acima do peso",
    obese: "Faixa de obesidade",
    enterHeightWeight: "Informe altura e peso",
    enterHeightWeightHint: "Os dois valores são necessários para o cálculo.",
    profileDietitianNote: "Ao perguntar, o nutricionista online usa este breve resumo sem alterar os controles de custo.",
    profileLinkedToDietitian: "Seu perfil está ligado ao nutricionista",
    profileNotCompleted: "Perfil incompleto",
    profileNotCompletedHint: "Adicione altura e peso no perfil para orientações mais pessoais.",
    nutrition: "Informações nutricionais",
    nutritionIntro: "Veja calorias, macros, minerais, vitaminas e percentuais diários por 100 gramas.",
    nutritionSearchPlaceholder: "Exemplo: ovo, iogurte, abacate...",
    searchNutrition: "Buscar nutrientes",
    refreshFromSources: "Atualizar das fontes",
    nutritionLoading: "Buscando dados nutricionais...",
    nutritionPer100g: "Valores por 100 gramas",
    nutritionConfidenceHigh: "Alta confiança",
    nutritionConfidenceMedium: "Confiança média",
    nutritionConfidenceLow: "Baixa confiança",
    viewSource: "Abrir fonte",
    vitaminsMinerals: "Vitaminas e minerais",
    dailyValueChart: "Cobertura do valor diário",
    macroDistribution: "Distribuição de macros",
    nutritionNotFound: "Nenhum dado nutricional encontrado",
    nutritionNotFoundHint: "Tente outro nome de alimento ou um termo mais geral."
  },
  es: {
    ...EXTRA_TRANSLATIONS.es,
    myProfile: "Mi perfil",
    profileIntro: "Guarda altura y peso; calculamos tu rango de peso saludable y el dietista online puede usarlo.",
    profileLoginRequired: "Inicia sesión para tu perfil",
    profileLoginHint: "La altura y el peso solo se guardan en cuentas conectadas.",
    heightCm: "Altura (cm)",
    weightKg: "Peso (kg)",
    saveProfile: "Guardar perfil",
    profileSaved: "Perfil guardado",
    idealWeightResult: "Cálculo de peso saludable",
    idealWeightRange: "Rango de peso saludable",
    bmi: "IMC",
    bmiCategory: "Estado del IMC",
    neutralTarget: "Objetivo medio",
    underweight: "Bajo peso",
    overweight: "Sobrepeso",
    obese: "Rango de obesidad",
    enterHeightWeight: "Introduce altura y peso",
    enterHeightWeightHint: "Ambos valores son necesarios para el cálculo.",
    profileDietitianNote: "Cuando haces una pregunta, el dietista online usa este breve resumen sin cambiar los controles de coste.",
    profileLinkedToDietitian: "Tu perfil está vinculado al dietista",
    profileNotCompleted: "Perfil incompleto",
    profileNotCompletedHint: "Añade altura y peso en tu perfil para consejos más personales.",
    nutrition: "Información nutricional",
    nutritionIntro: "Consulta calorías, macros, minerales, vitaminas y porcentajes diarios por 100 gramos.",
    nutritionSearchPlaceholder: "Ejemplo: huevo, yogur, aguacate...",
    searchNutrition: "Buscar nutrientes",
    refreshFromSources: "Actualizar desde fuentes",
    nutritionLoading: "Buscando datos nutricionales...",
    nutritionPer100g: "Valores por 100 gramos",
    nutritionConfidenceHigh: "Alta confianza",
    nutritionConfidenceMedium: "Confianza media",
    nutritionConfidenceLow: "Baja confianza",
    viewSource: "Abrir fuente",
    vitaminsMinerals: "Vitaminas y minerales",
    dailyValueChart: "Cobertura del valor diario",
    macroDistribution: "Distribución de macros",
    nutritionNotFound: "No se encontraron datos nutricionales",
    nutritionNotFoundHint: "Prueba con otro alimento o un nombre más general."
  },
  ja: {
    ...EXTRA_TRANSLATIONS.ja,
    myProfile: "マイプロフィール",
    profileIntro: "身長と体重を保存すると、健康的な体重範囲を計算し、オンライン栄養士が参考にできます。",
    profileLoginRequired: "プロフィールにはログインが必要です",
    profileLoginHint: "身長と体重はログイン中のアカウントにのみ保存されます。",
    heightCm: "身長 (cm)",
    weightKg: "体重 (kg)",
    saveProfile: "プロフィールを保存",
    profileSaved: "プロフィールを保存しました",
    idealWeightResult: "健康体重の計算",
    idealWeightRange: "健康的な体重範囲",
    bmi: "BMI",
    bmiCategory: "BMI区分",
    neutralTarget: "中間目標",
    underweight: "低体重",
    overweight: "過体重",
    obese: "肥満範囲",
    enterHeightWeight: "身長と体重を入力",
    enterHeightWeightHint: "計算には両方の値が必要です。",
    profileDietitianNote: "質問時、オンライン栄養士はこの短いプロフィール要約を使用します。コスト制御は変わりません。",
    profileLinkedToDietitian: "プロフィールが栄養士に連携されています",
    profileNotCompleted: "プロフィール未完成",
    profileNotCompletedHint: "プロフィールに身長と体重を追加すると、より個別の提案になります。",
    nutrition: "栄養成分",
    nutritionIntro: "100gあたりのカロリー、栄養素、ミネラル、ビタミン、1日摂取目安の割合を確認します。",
    nutritionSearchPlaceholder: "例：卵、ヨーグルト、アボカド...",
    searchNutrition: "栄養を検索",
    refreshFromSources: "情報源から更新",
    nutritionLoading: "栄養データを検索中...",
    nutritionPer100g: "100gあたりの値",
    nutritionConfidenceHigh: "信頼度 高",
    nutritionConfidenceMedium: "信頼度 中",
    nutritionConfidenceLow: "信頼度 低",
    viewSource: "情報源を開く",
    vitaminsMinerals: "ビタミン・ミネラル",
    dailyValueChart: "1日摂取目安のカバー率",
    macroDistribution: "マクロ栄養素の割合",
    nutritionNotFound: "栄養データが見つかりません",
    nutritionNotFoundHint: "別の食品名、またはより一般的な名前で試してください。"
  },
  zh: {
    ...EXTRA_TRANSLATIONS.zh,
    myProfile: "我的资料",
    profileIntro: "保存身高和体重；系统会计算健康体重范围，在线营养师也会参考。",
    profileLoginRequired: "请登录后使用资料",
    profileLoginHint: "身高和体重只会保存到已登录账号。",
    heightCm: "身高 (cm)",
    weightKg: "体重 (kg)",
    saveProfile: "保存资料",
    profileSaved: "资料已保存",
    idealWeightResult: "健康体重计算",
    idealWeightRange: "健康体重范围",
    bmi: "BMI",
    bmiCategory: "BMI 状态",
    neutralTarget: "中间目标",
    underweight: "体重偏低",
    overweight: "超重",
    obese: "肥胖范围",
    enterHeightWeight: "输入身高和体重",
    enterHeightWeightHint: "计算需要两个数值。",
    profileDietitianNote: "提问时，在线营养师会使用这个简短资料摘要，费用控制不变。",
    profileLinkedToDietitian: "你的资料已连接到营养师",
    profileNotCompleted: "资料未完成",
    profileNotCompletedHint: "在资料中添加身高和体重，可获得更个性化的建议。",
    nutrition: "营养成分",
    nutritionIntro: "查看每100克的热量、宏量营养素、矿物质、维生素和每日需求百分比。",
    nutritionSearchPlaceholder: "例如：鸡蛋、酸奶、牛油果...",
    searchNutrition: "搜索营养",
    refreshFromSources: "从来源刷新",
    nutritionLoading: "正在搜索营养数据...",
    nutritionPer100g: "每100克数值",
    nutritionConfidenceHigh: "高可信度",
    nutritionConfidenceMedium: "中等可信度",
    nutritionConfidenceLow: "低可信度",
    viewSource: "打开来源",
    vitaminsMinerals: "维生素和矿物质",
    dailyValueChart: "每日需求覆盖率",
    macroDistribution: "宏量营养分布",
    nutritionNotFound: "未找到营养数据",
    nutritionNotFoundHint: "请尝试其他或更通用的食物名称。"
  },
  ko: {
    ...EXTRA_TRANSLATIONS.ko,
    myProfile: "내 프로필",
    profileIntro: "키와 몸무게를 저장하면 건강 체중 범위를 계산하고 온라인 영양사가 참고합니다.",
    profileLoginRequired: "프로필을 사용하려면 로그인하세요",
    profileLoginHint: "키와 몸무게는 로그인한 계정에만 저장됩니다.",
    heightCm: "키 (cm)",
    weightKg: "몸무게 (kg)",
    saveProfile: "프로필 저장",
    profileSaved: "프로필이 저장되었습니다",
    idealWeightResult: "건강 체중 계산",
    idealWeightRange: "건강 체중 범위",
    bmi: "BMI",
    bmiCategory: "BMI 상태",
    neutralTarget: "중간 목표",
    underweight: "저체중",
    overweight: "과체중",
    obese: "비만 범위",
    enterHeightWeight: "키와 몸무게 입력",
    enterHeightWeightHint: "계산에는 두 값이 모두 필요합니다.",
    profileDietitianNote: "질문할 때 온라인 영양사는 이 짧은 프로필 요약을 사용하며 비용 제어는 그대로 유지됩니다.",
    profileLinkedToDietitian: "프로필이 영양사와 연결되었습니다",
    profileNotCompleted: "프로필 미완성",
    profileNotCompletedHint: "프로필에 키와 몸무게를 추가하면 더 개인화된 조언을 받을 수 있습니다.",
    nutrition: "영양 성분",
    nutritionIntro: "100g 기준 칼로리, 탄수화물, 지방, 단백질, 비타민, 미네랄과 일일 기준치를 확인합니다.",
    nutritionSearchPlaceholder: "예: 달걀, 요거트, 아보카도...",
    searchNutrition: "영양 검색",
    refreshFromSources: "출처에서 새로고침",
    nutritionLoading: "영양 데이터를 검색 중...",
    nutritionPer100g: "100g당 값",
    nutritionConfidenceHigh: "높은 신뢰도",
    nutritionConfidenceMedium: "중간 신뢰도",
    nutritionConfidenceLow: "낮은 신뢰도",
    viewSource: "출처 열기",
    vitaminsMinerals: "비타민과 미네랄",
    dailyValueChart: "일일 기준치 충족률",
    macroDistribution: "매크로 분포",
    nutritionNotFound: "영양 데이터를 찾지 못했습니다",
    nutritionNotFoundHint: "다른 음식명이나 더 일반적인 이름을 시도하세요."
  },
  ar: {
    ...EXTRA_TRANSLATIONS.ar,
    myProfile: "ملفي الشخصي",
    profileIntro: "احفظ الطول والوزن ليتم حساب نطاق الوزن الصحي ويستخدمه أخصائي التغذية عند الحاجة.",
    profileLoginRequired: "سجّل الدخول لاستخدام الملف الشخصي",
    profileLoginHint: "يتم حفظ الطول والوزن فقط في الحسابات المسجلة.",
    heightCm: "الطول (سم)",
    weightKg: "الوزن (كجم)",
    saveProfile: "حفظ الملف",
    profileSaved: "تم حفظ الملف الشخصي",
    idealWeightResult: "حساب الوزن الصحي",
    idealWeightRange: "نطاق الوزن الصحي",
    bmi: "مؤشر كتلة الجسم",
    bmiCategory: "حالة المؤشر",
    neutralTarget: "هدف متوسط",
    underweight: "نقص وزن",
    overweight: "زيادة وزن",
    obese: "نطاق السمنة",
    enterHeightWeight: "أدخل الطول والوزن",
    enterHeightWeightHint: "القيمتان مطلوبتان للحساب.",
    profileDietitianNote: "عند طرح سؤال، يستخدم أخصائي التغذية هذا الملخص القصير دون تغيير ضوابط التكلفة.",
    profileLinkedToDietitian: "تم ربط ملفك بأخصائي التغذية",
    profileNotCompleted: "الملف غير مكتمل",
    profileNotCompletedHint: "أضف الطول والوزن في الملف للحصول على إرشادات أكثر تخصيصاً.",
    nutrition: "القيم الغذائية",
    nutritionIntro: "اعرض السعرات والمغذيات والمعادن والفيتامينات ونسبة الاحتياج اليومي لكل 100 غرام.",
    nutritionSearchPlaceholder: "مثال: بيض، زبادي، أفوكادو...",
    searchNutrition: "ابحث عن القيم",
    refreshFromSources: "تحديث من المصادر",
    nutritionLoading: "جارٍ البحث عن البيانات الغذائية...",
    nutritionPer100g: "القيم لكل 100 غرام",
    nutritionConfidenceHigh: "ثقة عالية",
    nutritionConfidenceMedium: "ثقة متوسطة",
    nutritionConfidenceLow: "ثقة منخفضة",
    viewSource: "فتح المصدر",
    vitaminsMinerals: "الفيتامينات والمعادن",
    dailyValueChart: "نسبة تلبية الاحتياج اليومي",
    macroDistribution: "توزيع المغذيات الكبرى",
    nutritionNotFound: "لم يتم العثور على بيانات غذائية",
    nutritionNotFoundHint: "جرّب اسم طعام آخر أو اسماً أكثر عمومية."
  }
});

Object.assign(EXTRA_TRANSLATIONS, {
  pt: {
    ...EXTRA_TRANSLATIONS.pt,
    designSettings: "Configurações de design",
    designSettingsIntro: "Altere o título do app, fontes, tamanho do texto, cores dos botões e ícones do menu.",
    appTitle: "Título do app",
    bodyFont: "Fonte do texto",
    headingFont: "Fonte dos títulos",
    baseFontSize: "Tamanho base do texto",
    headingScale: "Escala dos títulos",
    buttonRadius: "Arredondamento dos botões",
    primaryButtonColor: "Cor do botão principal",
    primaryButtonHover: "Cor do botão principal ao passar o cursor",
    successButtonColor: "Cor do botão verde",
    buttonTextColor: "Cor do texto do botão",
    saveDesignSettings: "Salvar design",
    designSettingsSaved: "Configurações de design salvas"
  },
  es: {
    ...EXTRA_TRANSLATIONS.es,
    designSettings: "Ajustes de diseño",
    designSettingsIntro: "Cambia el título de la app, fuentes, tamaño del texto, colores de botones e iconos del menú.",
    appTitle: "Título de la app",
    bodyFont: "Fuente del texto",
    headingFont: "Fuente de los títulos",
    baseFontSize: "Tamaño base del texto",
    headingScale: "Escala de títulos",
    buttonRadius: "Redondeo de botones",
    primaryButtonColor: "Color del botón principal",
    primaryButtonHover: "Color del botón principal al pasar el cursor",
    successButtonColor: "Color del botón verde",
    buttonTextColor: "Color del texto del botón",
    saveDesignSettings: "Guardar diseño",
    designSettingsSaved: "Ajustes de diseño guardados"
  },
  ja: {
    ...EXTRA_TRANSLATIONS.ja,
    designSettings: "デザイン設定",
    designSettingsIntro: "アプリ名、フォント、文字サイズ、ボタン色、メニューアイコンを変更します。",
    appTitle: "アプリ名",
    bodyFont: "本文フォント",
    headingFont: "見出しフォント",
    baseFontSize: "基本文字サイズ",
    headingScale: "見出し倍率",
    buttonRadius: "ボタンの角丸",
    primaryButtonColor: "メインボタン色",
    primaryButtonHover: "メインボタンのホバー色",
    successButtonColor: "緑ボタン色",
    buttonTextColor: "ボタン文字色",
    saveDesignSettings: "デザインを保存",
    designSettingsSaved: "デザイン設定を保存しました"
  },
  zh: {
    ...EXTRA_TRANSLATIONS.zh,
    designSettings: "设计设置",
    designSettingsIntro: "修改应用标题、字体、文字大小、按钮颜色和菜单图标。",
    appTitle: "应用标题",
    bodyFont: "正文字体",
    headingFont: "标题字体",
    baseFontSize: "基础文字大小",
    headingScale: "标题比例",
    buttonRadius: "按钮圆角",
    primaryButtonColor: "主按钮颜色",
    primaryButtonHover: "主按钮悬停颜色",
    successButtonColor: "绿色按钮颜色",
    buttonTextColor: "按钮文字颜色",
    saveDesignSettings: "保存设计",
    designSettingsSaved: "设计设置已保存"
  },
  ko: {
    ...EXTRA_TRANSLATIONS.ko,
    designSettings: "디자인 설정",
    designSettingsIntro: "앱 제목, 글꼴, 글자 크기, 버튼 색상과 메뉴 아이콘을 변경합니다.",
    appTitle: "앱 제목",
    bodyFont: "본문 글꼴",
    headingFont: "제목 글꼴",
    baseFontSize: "기본 글자 크기",
    headingScale: "제목 크기 비율",
    buttonRadius: "버튼 모서리",
    primaryButtonColor: "기본 버튼 색상",
    primaryButtonHover: "기본 버튼 호버 색상",
    successButtonColor: "초록 버튼 색상",
    buttonTextColor: "버튼 글자 색상",
    saveDesignSettings: "디자인 저장",
    designSettingsSaved: "디자인 설정이 저장되었습니다"
  },
  ar: {
    ...EXTRA_TRANSLATIONS.ar,
    designSettings: "إعدادات التصميم",
    designSettingsIntro: "غيّر عنوان التطبيق والخطوط وحجم النص وألوان الأزرار وأيقونات القائمة.",
    appTitle: "عنوان التطبيق",
    bodyFont: "خط النص",
    headingFont: "خط العناوين",
    baseFontSize: "حجم النص الأساسي",
    headingScale: "مقياس العناوين",
    buttonRadius: "استدارة الأزرار",
    primaryButtonColor: "لون الزر الرئيسي",
    primaryButtonHover: "لون الزر الرئيسي عند المرور",
    successButtonColor: "لون الزر الأخضر",
    buttonTextColor: "لون نص الزر",
    saveDesignSettings: "حفظ التصميم",
    designSettingsSaved: "تم حفظ إعدادات التصميم"
  }
});

Object.assign(EXTRA_TRANSLATIONS, {
  de: {
    ...EXTRA_TRANSLATIONS.de,
    myProfile: "Mein Profil",
    profileIntro: "Speichere Größe und Gewicht; der gesunde Gewichtsbereich wird berechnet und die Online-Ernährungsberatung kann ihn berücksichtigen.",
    profileLoginRequired: "Für das Profil anmelden",
    profileLoginHint: "Größe und Gewicht werden nur im angemeldeten Konto gespeichert.",
    heightCm: "Größe (cm)",
    weightKg: "Gewicht (kg)",
    saveProfile: "Profil speichern",
    profileSaved: "Profil gespeichert",
    idealWeightResult: "Berechnung des gesunden Gewichts",
    idealWeightRange: "Gesunder Gewichtsbereich",
    bmi: "BMI",
    bmiCategory: "BMI-Status",
    neutralTarget: "Mittleres Ziel",
    underweight: "Untergewicht",
    overweight: "Übergewicht",
    obese: "Adipositasbereich",
    enterHeightWeight: "Größe und Gewicht eingeben",
    enterHeightWeightHint: "Für die Berechnung werden beide Werte benötigt.",
    profileDietitianNote: "Bei Fragen nutzt die Online-Ernährungsberatung diese kurze Profilzusammenfassung, ohne die Kostenkontrollen zu ändern.",
    profileLinkedToDietitian: "Dein Profil ist mit der Ernährungsberatung verbunden",
    profileNotCompleted: "Profil unvollständig",
    profileNotCompletedHint: "Ergänze Größe und Gewicht im Profil für persönlichere Hinweise."
  },
  it: {
    ...EXTRA_TRANSLATIONS.it,
    myProfile: "Il mio profilo",
    profileIntro: "Salva altezza e peso; calcoliamo il tuo intervallo di peso sano e il dietista online può usarlo.",
    profileLoginRequired: "Accedi per il profilo",
    profileLoginHint: "Altezza e peso vengono salvati solo negli account con accesso.",
    heightCm: "Altezza (cm)",
    weightKg: "Peso (kg)",
    saveProfile: "Salva profilo",
    profileSaved: "Profilo salvato",
    idealWeightResult: "Calcolo del peso sano",
    idealWeightRange: "Intervallo di peso sano",
    bmi: "BMI",
    bmiCategory: "Stato BMI",
    neutralTarget: "Obiettivo medio",
    underweight: "Sottopeso",
    overweight: "Sovrappeso",
    obese: "Fascia obesità",
    enterHeightWeight: "Inserisci altezza e peso",
    enterHeightWeightHint: "Entrambi i valori sono necessari per il calcolo.",
    profileDietitianNote: "Quando fai una domanda, il dietista online usa questo breve riepilogo senza modificare i controlli dei costi.",
    profileLinkedToDietitian: "Il profilo è collegato al dietista",
    profileNotCompleted: "Profilo incompleto",
    profileNotCompletedHint: "Aggiungi altezza e peso nel profilo per consigli più personali."
  },
  pt: {
    ...EXTRA_TRANSLATIONS.pt,
    myProfile: "Meu perfil",
    profileIntro: "Salve altura e peso; calculamos sua faixa de peso saudável e o nutricionista online pode usá-la.",
    profileLoginRequired: "Entre para acessar o perfil",
    profileLoginHint: "Altura e peso são salvos apenas em contas conectadas.",
    heightCm: "Altura (cm)",
    weightKg: "Peso (kg)",
    saveProfile: "Salvar perfil",
    profileSaved: "Perfil salvo",
    idealWeightResult: "Cálculo de peso saudável",
    idealWeightRange: "Faixa de peso saudável",
    bmi: "IMC",
    bmiCategory: "Status do IMC",
    neutralTarget: "Meta média",
    underweight: "Abaixo do peso",
    overweight: "Acima do peso",
    obese: "Faixa de obesidade",
    enterHeightWeight: "Informe altura e peso",
    enterHeightWeightHint: "Os dois valores são necessários para o cálculo.",
    profileDietitianNote: "Ao perguntar, o nutricionista online usa este breve resumo sem alterar os controles de custo.",
    profileLinkedToDietitian: "Seu perfil está ligado ao nutricionista",
    profileNotCompleted: "Perfil incompleto",
    profileNotCompletedHint: "Adicione altura e peso no perfil para orientações mais pessoais."
  },
  es: {
    ...EXTRA_TRANSLATIONS.es,
    myProfile: "Mi perfil",
    profileIntro: "Guarda altura y peso; calculamos tu rango de peso saludable y el dietista online puede usarlo.",
    profileLoginRequired: "Inicia sesión para tu perfil",
    profileLoginHint: "La altura y el peso solo se guardan en cuentas conectadas.",
    heightCm: "Altura (cm)",
    weightKg: "Peso (kg)",
    saveProfile: "Guardar perfil",
    profileSaved: "Perfil guardado",
    idealWeightResult: "Cálculo de peso saludable",
    idealWeightRange: "Rango de peso saludable",
    bmi: "IMC",
    bmiCategory: "Estado del IMC",
    neutralTarget: "Objetivo medio",
    underweight: "Bajo peso",
    overweight: "Sobrepeso",
    obese: "Rango de obesidad",
    enterHeightWeight: "Introduce altura y peso",
    enterHeightWeightHint: "Ambos valores son necesarios para el cálculo.",
    profileDietitianNote: "Cuando haces una pregunta, el dietista online usa este breve resumen sin cambiar los controles de coste.",
    profileLinkedToDietitian: "Tu perfil está vinculado al dietista",
    profileNotCompleted: "Perfil incompleto",
    profileNotCompletedHint: "Añade altura y peso en tu perfil para consejos más personales."
  },
  ja: {
    ...EXTRA_TRANSLATIONS.ja,
    myProfile: "マイプロフィール",
    profileIntro: "身長と体重を保存すると、健康的な体重範囲を計算し、オンライン栄養士が参考にできます。",
    profileLoginRequired: "プロフィールにはログインが必要です",
    profileLoginHint: "身長と体重はログイン中のアカウントにのみ保存されます。",
    heightCm: "身長 (cm)",
    weightKg: "体重 (kg)",
    saveProfile: "プロフィールを保存",
    profileSaved: "プロフィールを保存しました",
    idealWeightResult: "健康体重の計算",
    idealWeightRange: "健康的な体重範囲",
    bmi: "BMI",
    bmiCategory: "BMI区分",
    neutralTarget: "中間目標",
    underweight: "低体重",
    overweight: "過体重",
    obese: "肥満範囲",
    enterHeightWeight: "身長と体重を入力",
    enterHeightWeightHint: "計算には両方の値が必要です。",
    profileDietitianNote: "質問時、オンライン栄養士はこの短いプロフィール要約を使用します。コスト制御は変わりません。",
    profileLinkedToDietitian: "プロフィールが栄養士に連携されています",
    profileNotCompleted: "プロフィール未完成",
    profileNotCompletedHint: "プロフィールに身長と体重を追加すると、より個別の提案になります。"
  },
  zh: {
    ...EXTRA_TRANSLATIONS.zh,
    myProfile: "我的资料",
    profileIntro: "保存身高和体重；系统会计算健康体重范围，在线营养师也会参考。",
    profileLoginRequired: "请登录后使用资料",
    profileLoginHint: "身高和体重只会保存到已登录账号。",
    heightCm: "身高 (cm)",
    weightKg: "体重 (kg)",
    saveProfile: "保存资料",
    profileSaved: "资料已保存",
    idealWeightResult: "健康体重计算",
    idealWeightRange: "健康体重范围",
    bmi: "BMI",
    bmiCategory: "BMI 状态",
    neutralTarget: "中间目标",
    underweight: "体重偏低",
    overweight: "超重",
    obese: "肥胖范围",
    enterHeightWeight: "输入身高和体重",
    enterHeightWeightHint: "计算需要两个数值。",
    profileDietitianNote: "提问时，在线营养师会使用这个简短资料摘要，费用控制不变。",
    profileLinkedToDietitian: "你的资料已连接到营养师",
    profileNotCompleted: "资料未完成",
    profileNotCompletedHint: "在资料中添加身高和体重，可获得更个性化的建议。"
  },
  ko: {
    ...EXTRA_TRANSLATIONS.ko,
    myProfile: "내 프로필",
    profileIntro: "키와 몸무게를 저장하면 건강 체중 범위를 계산하고 온라인 영양사가 참고합니다.",
    profileLoginRequired: "프로필을 사용하려면 로그인하세요",
    profileLoginHint: "키와 몸무게는 로그인한 계정에만 저장됩니다.",
    heightCm: "키 (cm)",
    weightKg: "몸무게 (kg)",
    saveProfile: "프로필 저장",
    profileSaved: "프로필이 저장되었습니다",
    idealWeightResult: "건강 체중 계산",
    idealWeightRange: "건강 체중 범위",
    bmi: "BMI",
    bmiCategory: "BMI 상태",
    neutralTarget: "중간 목표",
    underweight: "저체중",
    overweight: "과체중",
    obese: "비만 범위",
    enterHeightWeight: "키와 몸무게 입력",
    enterHeightWeightHint: "계산에는 두 값이 모두 필요합니다.",
    profileDietitianNote: "질문할 때 온라인 영양사는 이 짧은 프로필 요약을 사용하며 비용 제어는 그대로 유지됩니다.",
    profileLinkedToDietitian: "프로필이 영양사와 연결되었습니다",
    profileNotCompleted: "프로필 미완성",
    profileNotCompletedHint: "프로필에 키와 몸무게를 추가하면 더 개인화된 조언을 받을 수 있습니다."
  },
  ar: {
    ...EXTRA_TRANSLATIONS.ar,
    myProfile: "ملفي الشخصي",
    profileIntro: "احفظ الطول والوزن ليتم حساب نطاق الوزن الصحي ويستخدمه أخصائي التغذية عند الحاجة.",
    profileLoginRequired: "سجّل الدخول لاستخدام الملف الشخصي",
    profileLoginHint: "يتم حفظ الطول والوزن فقط في الحسابات المسجلة.",
    heightCm: "الطول (سم)",
    weightKg: "الوزن (كجم)",
    saveProfile: "حفظ الملف",
    profileSaved: "تم حفظ الملف الشخصي",
    idealWeightResult: "حساب الوزن الصحي",
    idealWeightRange: "نطاق الوزن الصحي",
    bmi: "مؤشر كتلة الجسم",
    bmiCategory: "حالة المؤشر",
    neutralTarget: "هدف متوسط",
    underweight: "نقص وزن",
    overweight: "زيادة وزن",
    obese: "نطاق السمنة",
    enterHeightWeight: "أدخل الطول والوزن",
    enterHeightWeightHint: "القيمتان مطلوبتان للحساب.",
    profileDietitianNote: "عند طرح سؤال، يستخدم أخصائي التغذية هذا الملخص القصير دون تغيير ضوابط التكلفة.",
    profileLinkedToDietitian: "تم ربط ملفك بأخصائي التغذية",
    profileNotCompleted: "الملف غير مكتمل",
    profileNotCompletedHint: "أضف الطول والوزن في الملف للحصول على إرشادات أكثر تخصيصاً."
  }
});

Object.assign(EXTRA_TRANSLATIONS, {
  ar: {
    brand: "FitDish",
    daily: "الخطة اليومية",
    meals: "الأطباق",
    desserts: "الحلويات",
    addRecipe: "إضافة وصفة",
    favorites: "المفضلة",
    shopping: "التسوق",
    dietitian: "أخصائي تغذية عبر الإنترنت",
    signIn: "تسجيل الدخول",
    signOut: "تسجيل الخروج",
    language: "اللغة",
    dailyIntro: "Where flavor meets wellness.",
    allMealsIntro: "استكشف الوصفات حسب الوجبة والمطبخ والفئة والسعرات.",
    dessertsIntro: "اكتشف حلويات كريمية وفاكهية وصحية وعالمية مع معلومات السعرات.",
    all: "الكل",
    healthy: "صحي",
    tasty: "لذيذ",
    balanced: "متوازن",
    fitHealthy: "صحي / خفيف",
    breakfast: "فطور",
    lunch: "غداء",
    dinner: "عشاء",
    dessert: "حلوى",
    meal: "وجبة",
    category: "الفئة",
    cuisine: "المطبخ",
    allMealsFilter: "كل الوجبات",
    allCuisines: "كل المطابخ",
    allWorldCuisines: "كل مطابخ العالم",
    allDessertTypes: "كل أنواع الحلويات",
    dessertType: "نوع الحلوى",
    newPlan: "خطة جديدة",
    loadingDaily: "جارٍ تحضير الخطة اليومية...",
    loadingMeals: "جارٍ تحميل الأطباق...",
    loadingDesserts: "جارٍ تحميل الحلويات...",
    totalDailyCalories: "إجمالي السعرات التقريبي للوجبات الثلاث الرئيسية اليوم",
    cachedPlan: "تم تحميل خطة اليوم من المحفوظات.",
    noMealFound: "لم يتم العثور على طبق",
    noDessertFound: "لم يتم العثور على حلوى",
    tryDifferentFilters: "غيّر المرشحات وحاول مرة أخرى.",
    mealsFound: "طبقاً تم العثور عليه",
    dessertsFound: "حلوى تم العثور عليها",
    noSlotSuggestion: "لا توجد اقتراحات لهذه المرشحات.",
    searchMeals: "ابحث عن طبق أو مطبخ أو مكوّن...",
    searchDesserts: "ابحث عن حلوى أو مكوّن...",
    minutes: "دقيقة",
    kcal: "سعرة",
    ingredientUnit: "مكوّن",
    addOwnRecipe: "أضف وصفتك",
    addRecipeIntro: "احفظ أطباقك أو حلوياتك بخطوات بسيطة.",
    addRecipeLoginNote: "يجب تسجيل الدخول قبل إضافة وصفة.",
    loginRequiredRecipe: "سجّل الدخول لإضافة وصفة.",
    recipeName: "اسم الوصفة",
    mealType: "نوع الوجبة",
    calories: "السعرات",
    prepTime: "التحضير",
    cookTime: "الطهي",
    prepMinutes: "التحضير (دقيقة)",
    cookMinutes: "الطهي (دقيقة)",
    servings: "الحصص",
    ingredients: "المكوّنات",
    steps: "خطوات التحضير",
    youtubeUrl: "رابط فيديو YouTube",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saveRecipe: "حفظ الوصفة",
    saving: "جارٍ الحفظ...",
    recipeSaved: "تم حفظ الوصفة",
    ingredientsPlaceholder: "اكتب مكوّناً في كل سطر أو افصل بينها بفواصل",
    stepsPlaceholder: "اكتب خطوة في كل سطر",
    recipeNamePlaceholder: "مثال: معكرونة منزلية بالخضار",
    rateRecipe: "قيّم هذه الوصفة",
    socialInfo: "بنية تسجيل الدخول الاجتماعي جاهزة. يمكن ربط مفاتيح OAuth الحقيقية لاحقاً.",
    favoriteAdd: "أضف إلى المفضلة",
    favoriteRemove: "إزالة من المفضلة",
    favoriteAdded: "تمت الإضافة إلى المفضلة",
    favoriteRemoved: "تمت الإزالة من المفضلة",
    back: "رجوع",
    backToMeals: "العودة إلى الأطباق",
    noMealSelected: "لم يتم اختيار طبق",
    addAllIngredients: "إضافة المكوّنات إلى القائمة",
    addToList: "+ القائمة",
    added: "تمت الإضافة",
    alreadyOnList: "موجود بالفعل في القائمة",
    ingredientAdded: "تمت إضافته إلى القائمة",
    ingredientsAddedToShopping: "تمت إضافة المكوّنات إلى قائمة التسوق",
    videoRecipe: "وصفة بالفيديو",
    rateLoginRequired: "سجّل الدخول لتقييم الوصفة.",
    ratingSaved: "تم حفظ التقييم",
    noRatingYet: "لا توجد تقييمات بعد",
    dietitianIntro: "نصائح قصيرة وعملية يومياً للتغذية ونمط الحياة.",
    dailyNutritionAdvice: "نصيحة يومية للتغذية ونمط الحياة",
    dailyTips: "نصائح اليوم",
    suggestedFoodToday: "الغذاء المقترح اليوم:",
    adviceLoading: "جارٍ تحضير نصيحة اليوم...",
    adviceLoadFailed: "تعذر تحميل النصيحة",
    checkBackendOrKey: "تحقق من اتصال الخادم أو مفتاح API.",
    askDietitian: "اسأل أخصائي التغذية",
    medicalDisclaimer: "هذا القسم للمعلومات العامة ولا يغني عن التشخيص أو العلاج الشخصي.",
    askPlaceholder: "مثال: ماذا أختار لعشاء أخف؟",
    answerPreparing: "جارٍ تحضير الإجابة...",
    cannotAnswerNow: "لا يمكنني الإجابة الآن. يرجى المحاولة لاحقاً.",
    wait: "انتظر",
    ask: "اسأل",
    favoritesIntro: "صل بسرعة إلى الأطباق والحلويات التي أعجبتك.",
    noFavorites: "لا توجد وصفات مفضلة بعد",
    favoriteHint: "اضغط على القلب في بطاقات الوصفات لإضافتها إلى المفضلة.",
    browseMeals: "تصفح الأطباق",
    favoriteRecipeCount: "وصفات مفضلة",
    shoppingIntro: "تابع المكوّنات الناقصة المضافة من الوصفات.",
    list: "القائمة",
    waiting: "بانتظار",
    completed: "مكتمل",
    clearCompleted: "حذف المكتمل",
    emptyList: "القائمة فارغة",
    shoppingEmptyHint: "يمكنك إضافة المكوّنات من صفحات تفاصيل الوصفات.",
    purchased: "تم شراؤه",
    addNewIngredient: "أضف مكوّناً جديداً...",
    add: "إضافة",
    delete: "حذف",
    purchasedCleared: "تم حذف العناصر المشتراة",
    ingredientSuggest: "اقتراح حسب المكوّنات",
    ingredientSuggestIntro: "أدخل ما لديك من مكوّنات وسنجد الوصفات المناسبة.",
    yourIngredients: "مكوّناتك",
    addIngredientPlaceholder: "أضف مكوّناً (مثال: طماطم، بيض...)",
    searching: "جارٍ البحث...",
    findRecipe: "ابحث عن وصفات",
    clear: "مسح",
    searchingRecipes: "جارٍ البحث عن الوصفات...",
    recipesFound: "وصفة تم العثور عليها",
    noMatchingRecipe: "لم يتم العثور على وصفات مطابقة",
    tryDifferentIngredients: "جرّب مكوّنات مختلفة.",
    match: "نسبة التطابق",
    availableIngredients: "مكوّنات متوفرة",
    missingIngredients: "المكوّنات الناقصة:",
    addMissingToList: "أضف الناقص إلى القائمة",
    exactMatches: "تطابق كامل",
    partialMatches: "وصفات بمكوّنات ناقصة",
    aiIngredientHelp: "رأي الشيف بالذكاء الاصطناعي",
    aiIngredientResult: "رأي الشيف بالذكاء الاصطناعي",
    ingredientAiLocked: "اقتراح الذكاء الاصطناعي مقفل",
    ingredientAiLockedHint: "إذا لم تكن مشتركاً بريميوم، يمكنك مشاهدة إعلان مكافأة للحصول على 3 اقتراحات ذكاء اصطناعي يومياً كحد أقصى.",
    ingredientAiRewardConfirm: "ستشاهد محاكاة إعلان مكافأة للحصول على اقتراح مكوّنات واحد بالذكاء الاصطناعي. هل تريد المتابعة؟",
    watchAdForAi: "شاهد إعلاناً واحصل على اقتراح AI",
    continueWith: "المتابعة باستخدام",
    requestFailed: "فشل الطلب",
    translationNeedsKey: "الترجمة الكاملة للوصفة تحتاج إلى مفتاح API؛ تم توطين الفئات والتسميات.",
    admin: "المشرف",
    adminPanel: "لوحة المشرف",
    adminPanelIntro: "راجع وصفات المستخدمين قبل نشرها.",
    adminAccessRequired: "تسجيل دخول المشرف مطلوب",
    adminAccessHint: "هذا القسم يفتح فقط للحساب المطابق لـ ADMIN_EMAIL.",
    status: "الحالة",
    pending: "قيد الانتظار",
    approved: "موافق عليه",
    rejected: "مرفوض",
    loadingRecipes: "جارٍ تحميل الوصفات...",
    noModerationRecipes: "لا توجد وصفات للمراجعة",
    noModerationRecipesHint: "لا توجد وصفات بهذه الحالة.",
    approve: "موافقة",
    reject: "رفض",
    preview: "معاينة",
    recipeApproved: "تمت الموافقة على الوصفة",
    recipeRejected: "تم رفض الوصفة",
    recipePendingReview: "تم حفظ الوصفة وإرسالها لمراجعة المشرف.",
    emailAddress: "البريد الإلكتروني",
    displayName: "الاسم الظاهر",
    recipeImage: "صورة الوصفة",
    recipeImageHint: "JPG أو PNG أو WEBP؛ الحد الأقصى 2 MB.",
    changeImage: "تغيير الصورة",
    recipeImageUpdated: "تم تحديث صورة الوصفة",
    saveChanges: "حفظ التغييرات",
    recipeContentUpdated: "تم تحديث محتوى الوصفة",
    recipeContentRequired: "لا يمكن ترك المكوّنات والخطوات فارغة."
  }
});

Object.assign(EXTRA_TRANSLATIONS, {
  ko: {
    dailyIntro: "Where flavor meets wellness.",
    allMealsIntro: "식사, 요리권, 카테고리, 칼로리별로 레시피를 탐색하세요.",
    dessertsIntro: "크리미, 과일, 건강식, 세계 디저트를 칼로리 정보와 함께 확인하세요.",
    all: "전체",
    fitHealthy: "핏 / 건강",
    allMealsFilter: "모든 식사",
    allCuisines: "모든 요리권",
    allWorldCuisines: "모든 세계 요리",
    allDessertTypes: "모든 디저트 종류",
    dessertType: "디저트 종류",
    newPlan: "새 계획",
    loadingDaily: "일일 식단을 준비 중...",
    loadingMeals: "요리를 불러오는 중...",
    loadingDesserts: "디저트를 불러오는 중...",
    totalDailyCalories: "오늘 세 끼 주요 식사의 예상 총칼로리",
    cachedPlan: "오늘의 계획을 저장된 데이터에서 불러왔습니다.",
    noMealFound: "요리를 찾을 수 없습니다",
    noDessertFound: "디저트를 찾을 수 없습니다",
    tryDifferentFilters: "필터를 바꿔 다시 시도하세요.",
    mealsFound: "개 요리 발견",
    dessertsFound: "개 디저트 발견",
    noSlotSuggestion: "이 필터에 맞는 추천이 없습니다.",
    searchMeals: "요리, 요리권 또는 재료 검색...",
    searchDesserts: "디저트 또는 재료 검색...",
    minutes: "분",
    kcal: "kcal",
    ingredientUnit: "재료",
    addOwnRecipe: "내 레시피 추가",
    addRecipeIntro: "내 요리나 디저트를 몇 단계로 저장하세요.",
    addRecipeLoginNote: "레시피를 추가하려면 로그인해야 합니다.",
    recipeName: "레시피 이름",
    mealType: "식사",
    calories: "칼로리",
    prepTime: "준비",
    cookTime: "조리",
    prepMinutes: "준비 (분)",
    cookMinutes: "조리 (분)",
    servings: "인분",
    ingredients: "재료",
    steps: "조리 단계",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saving: "저장 중...",
    recipeSaved: "레시피 저장됨",
    ingredientsPlaceholder: "재료를 한 줄씩 쓰거나 쉼표로 구분하세요",
    stepsPlaceholder: "단계를 한 줄씩 쓰세요",
    recipeNamePlaceholder: "예: 집밥식 채소 파스타",
    rateRecipe: "이 레시피 평가",
    socialInfo: "소셜 로그인 구조가 준비되었습니다. 실제 OAuth 키는 나중에 연결할 수 있습니다.",
    favoriteAdd: "즐겨찾기에 추가",
    favoriteRemove: "즐겨찾기에서 제거",
    favoriteAdded: "즐겨찾기에 추가됨",
    favoriteRemoved: "즐겨찾기에서 제거됨",
    back: "뒤로",
    backToMeals: "요리로 돌아가기",
    noMealSelected: "선택된 요리가 없습니다",
    addAllIngredients: "재료를 목록에 추가",
    addToList: "+ 목록",
    added: "추가됨",
    alreadyOnList: "이미 목록에 있음",
    ingredientAdded: "목록에 추가됨",
    ingredientsAddedToShopping: "재료가 장보기 목록에 추가됨",
    videoRecipe: "동영상 레시피",
    rateLoginRequired: "평가하려면 로그인하세요.",
    ratingSaved: "평가 저장됨",
    noRatingYet: "아직 평가 없음",
    dietitianIntro: "매일 짧고 실용적인 영양 및 생활습관 조언을 제공합니다.",
    dailyNutritionAdvice: "일일 영양 및 생활 조언",
    dailyTips: "오늘의 팁",
    suggestedFoodToday: "오늘의 추천 식품:",
    adviceLoading: "오늘의 조언 준비 중...",
    adviceLoadFailed: "조언을 불러오지 못했습니다",
    checkBackendOrKey: "백엔드 연결 또는 API 키를 확인하세요.",
    askDietitian: "영양사에게 질문",
    medicalDisclaimer: "이 섹션은 일반 정보용이며 진단이나 치료를 대체하지 않습니다.",
    askPlaceholder: "예: 더 가벼운 저녁으로 무엇을 고를 수 있나요?",
    answerPreparing: "답변 준비 중...",
    cannotAnswerNow: "지금은 답변할 수 없습니다. 잠시 후 다시 시도하세요.",
    wait: "기다리기",
    ask: "질문",
    favoritesIntro: "좋아한 요리와 디저트에 빠르게 접근하세요.",
    noFavorites: "아직 즐겨찾기 레시피가 없습니다",
    favoriteHint: "카드의 하트를 눌러 즐겨찾기에 추가하세요.",
    browseMeals: "요리 둘러보기",
    favoriteRecipeCount: "즐겨찾기 레시피",
    shoppingIntro: "레시피에서 추가한 부족한 재료를 관리하세요.",
    list: "목록",
    waiting: "대기 중",
    completed: "완료",
    clearCompleted: "완료 항목 삭제",
    emptyList: "목록이 비어 있습니다",
    shoppingEmptyHint: "레시피 상세에서 재료를 추가할 수 있습니다.",
    purchased: "구매함",
    addNewIngredient: "새 재료 추가...",
    add: "추가",
    delete: "삭제",
    purchasedCleared: "구매한 항목 삭제됨",
    ingredientSuggest: "재료로 추천",
    ingredientSuggestIntro: "가지고 있는 재료를 입력하면 맞는 레시피를 찾아드립니다.",
    yourIngredients: "내 재료",
    addIngredientPlaceholder: "재료 추가 (예: 토마토, 달걀...)",
    searching: "검색 중...",
    findRecipe: "레시피 찾기",
    clear: "지우기",
    searchingRecipes: "레시피 검색 중...",
    recipesFound: "개 레시피 발견",
    noMatchingRecipe: "일치하는 레시피가 없습니다",
    tryDifferentIngredients: "다른 재료를 시도해 보세요.",
    match: "일치도",
    availableIngredients: "사용 가능한 재료",
    missingIngredients: "부족한 재료:",
    addMissingToList: "부족한 재료 목록에 추가",
    exactMatches: "완전 일치",
    partialMatches: "부족한 재료가 있는 레시피",
    aiIngredientHelp: "AI 셰프 조언",
    aiIngredientResult: "AI 셰프 조언",
    ingredientAiLocked: "AI 추천 잠김",
    ingredientAiLockedHint: "프리미엄이 아니면 보상형 광고를 보고 하루 최대 3개의 AI 추천을 받을 수 있습니다.",
    ingredientAiRewardConfirm: "보상형 광고 시뮬레이션을 보고 AI 재료 추천 1회를 얻습니다. 계속할까요?",
    watchAdForAi: "광고 보고 AI 추천 받기",
    continueWith: "계속하기:",
    requestFailed: "요청 실패",
    translationNeedsKey: "전체 레시피 번역에는 API 키가 필요합니다. 카테고리와 라벨은 현지화되었습니다.",
    admin: "관리자",
    adminPanel: "관리자 패널",
    adminPanelIntro: "사용자 레시피를 게시 전에 검토하세요.",
    adminAccessRequired: "관리자 로그인이 필요합니다",
    adminAccessHint: "이 영역은 ADMIN_EMAIL과 일치하는 계정에서만 열립니다.",
    status: "상태",
    pending: "대기 중",
    approved: "승인됨",
    rejected: "거절됨",
    loadingRecipes: "레시피 불러오는 중...",
    noModerationRecipes: "검토할 레시피가 없습니다",
    noModerationRecipesHint: "이 상태의 레시피가 없습니다.",
    approve: "승인",
    reject: "거절",
    preview: "미리보기",
    recipeApproved: "레시피 승인됨",
    recipeRejected: "레시피 거절됨",
    recipePendingReview: "레시피가 저장되어 관리자 검토로 전송되었습니다.",
    emailAddress: "이메일 주소",
    displayName: "표시 이름",
    recipeImage: "레시피 이미지",
    recipeImageHint: "JPG, PNG 또는 WEBP; 최대 2MB.",
    changeImage: "이미지 변경",
    recipeImageUpdated: "레시피 이미지 업데이트됨",
    saveChanges: "변경사항 저장",
    recipeContentUpdated: "레시피 내용 업데이트됨",
    recipeContentRequired: "재료와 단계는 비워둘 수 없습니다."
  }
});

Object.assign(EXTRA_TRANSLATIONS, {
  ja: {
    dailyIntro: "Where flavor meets wellness.",
    allMealsIntro: "食事、料理ジャンル、カテゴリ、カロリーでレシピを探せます。",
    dessertsIntro: "クリーミー、フルーツ、ヘルシー、世界のデザートをカロリー付きで探せます。",
    all: "すべて",
    fitHealthy: "ヘルシー / フィット",
    allMealsFilter: "すべての食事",
    allCuisines: "すべての料理",
    allWorldCuisines: "すべての世界料理",
    allDessertTypes: "すべてのデザート種類",
    dessertType: "デザート種類",
    newPlan: "新しいプラン",
    loadingDaily: "今日のプランを準備中...",
    loadingMeals: "料理を読み込み中...",
    loadingDesserts: "デザートを読み込み中...",
    totalDailyCalories: "今日の三食の推定総カロリー",
    cachedPlan: "今日のプランは保存済みデータから読み込まれました。",
    noMealFound: "料理が見つかりません",
    noDessertFound: "デザートが見つかりません",
    tryDifferentFilters: "条件を変更してもう一度お試しください。",
    mealsFound: "件の料理",
    dessertsFound: "件のデザート",
    noSlotSuggestion: "この条件では提案が見つかりません。",
    searchMeals: "料理、料理ジャンル、材料を検索...",
    searchDesserts: "デザートや材料を検索...",
    minutes: "分",
    kcal: "kcal",
    ingredientUnit: "材料",
    addOwnRecipe: "自分のレシピを追加",
    addRecipeIntro: "料理やデザートを簡単に保存できます。",
    addRecipeLoginNote: "レシピを追加するにはログインが必要です。",
    recipeName: "レシピ名",
    mealType: "食事",
    calories: "カロリー",
    prepTime: "準備",
    cookTime: "調理",
    prepMinutes: "準備（分）",
    cookMinutes: "調理（分）",
    servings: "人数分",
    ingredients: "材料",
    steps: "手順",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saving: "保存中...",
    recipeSaved: "レシピを保存しました",
    ingredientsPlaceholder: "材料を1行ずつ、またはカンマで区切って入力",
    stepsPlaceholder: "手順を1行ずつ入力",
    recipeNamePlaceholder: "例：家庭風野菜パスタ",
    rateRecipe: "このレシピを評価",
    socialInfo: "ソーシャルログインの基盤は準備済みです。実際のOAuthキーは後で接続できます。",
    favoriteAdd: "お気に入りに追加",
    favoriteRemove: "お気に入りから削除",
    favoriteAdded: "お気に入りに追加しました",
    favoriteRemoved: "お気に入りから削除しました",
    back: "戻る",
    backToMeals: "料理に戻る",
    noMealSelected: "料理が選択されていません",
    addAllIngredients: "材料をリストに追加",
    addToList: "+ リスト",
    added: "追加済み",
    alreadyOnList: "すでにリストにあります",
    ingredientAdded: "リストに追加されました",
    ingredientsAddedToShopping: "材料を買い物リストに追加しました",
    videoRecipe: "動画レシピ",
    rateLoginRequired: "評価するにはログインしてください。",
    ratingSaved: "評価を保存しました",
    noRatingYet: "まだ評価はありません",
    dietitianIntro: "毎日、栄養と生活習慣の短く実用的なアドバイスを表示します。",
    dailyNutritionAdvice: "毎日の栄養・生活アドバイス",
    dailyTips: "今日のヒント",
    suggestedFoodToday: "今日のおすすめ食品：",
    adviceLoading: "今日のアドバイスを準備中...",
    adviceLoadFailed: "アドバイスを読み込めませんでした",
    checkBackendOrKey: "バックエンド接続またはAPIキーを確認してください。",
    askDietitian: "栄養士に質問",
    medicalDisclaimer: "このセクションは一般情報であり、診断や治療の代わりではありません。",
    askPlaceholder: "例：軽めの夕食には何を選べますか？",
    answerPreparing: "回答を準備中...",
    cannotAnswerNow: "現在回答できません。少し後でもう一度お試しください。",
    wait: "待つ",
    ask: "質問",
    favoritesIntro: "気に入った料理やデザートにすばやくアクセスできます。",
    noFavorites: "お気に入りレシピはまだありません",
    favoriteHint: "カードのハートをタップしてお気に入りに追加できます。",
    browseMeals: "料理を見る",
    favoriteRecipeCount: "お気に入りレシピ",
    shoppingIntro: "レシピから追加した不足材料を管理します。",
    list: "リスト",
    waiting: "未完了",
    completed: "完了",
    clearCompleted: "完了を削除",
    emptyList: "リストは空です",
    shoppingEmptyHint: "レシピ詳細から材料を追加できます。",
    purchased: "購入済み",
    addNewIngredient: "新しい材料を追加...",
    add: "追加",
    delete: "削除",
    purchasedCleared: "購入済み項目を削除しました",
    ingredientSuggest: "材料から提案",
    ingredientSuggestIntro: "手元の材料を入力すると、合うレシピを探します。",
    yourIngredients: "手元の材料",
    addIngredientPlaceholder: "材料を追加（例：トマト、卵...）",
    searching: "検索中...",
    findRecipe: "レシピを探す",
    clear: "クリア",
    searchingRecipes: "レシピを検索中...",
    recipesFound: "件のレシピ",
    noMatchingRecipe: "一致するレシピがありません",
    tryDifferentIngredients: "別の材料を試してください。",
    match: "一致度",
    availableIngredients: "使用可能な材料",
    missingIngredients: "不足材料：",
    addMissingToList: "不足材料をリストに追加",
    exactMatches: "完全一致",
    partialMatches: "不足材料があるレシピ",
    aiIngredientHelp: "AIシェフの助言",
    aiIngredientResult: "AIシェフの助言",
    ingredientAiLocked: "AI提案はロックされています",
    ingredientAiLockedHint: "プレミアムでない場合、リワード広告を見ると1日最大3回AI提案を使えます。",
    ingredientAiRewardConfirm: "リワード広告シミュレーションを見てAI材料提案を1回獲得します。続行しますか？",
    watchAdForAi: "広告を見てAI提案を受ける",
    continueWith: "で続行",
    requestFailed: "リクエストに失敗しました",
    translationNeedsKey: "完全なレシピ翻訳にはAPIキーが必要です。カテゴリとラベルは翻訳済みです。",
    admin: "管理",
    adminPanel: "管理パネル",
    adminPanelIntro: "ユーザー投稿レシピを公開前に確認します。",
    adminAccessRequired: "管理者ログインが必要です",
    adminAccessHint: "この画面はADMIN_EMAILと一致するアカウントのみ開けます。",
    status: "状態",
    pending: "保留中",
    approved: "承認済み",
    rejected: "却下",
    loadingRecipes: "レシピを読み込み中...",
    noModerationRecipes: "確認するレシピはありません",
    noModerationRecipesHint: "この状態のレシピはありません。",
    approve: "承認",
    reject: "却下",
    preview: "プレビュー",
    recipeApproved: "レシピを承認しました",
    recipeRejected: "レシピを却下しました",
    recipePendingReview: "レシピを保存し、管理者確認に送信しました。",
    emailAddress: "メールアドレス",
    displayName: "表示名",
    recipeImage: "レシピ画像",
    recipeImageHint: "JPG、PNG、WEBP。最大2MB。",
    changeImage: "画像を変更",
    recipeImageUpdated: "レシピ画像を更新しました",
    saveChanges: "変更を保存",
    recipeContentUpdated: "レシピ内容を更新しました",
    recipeContentRequired: "材料と手順は空にできません。"
  },
  zh: {
    dailyIntro: "Where flavor meets wellness.",
    allMealsIntro: "按餐次、菜系、类别和热量浏览食谱。",
    dessertsIntro: "查看奶香、水果、轻食和世界甜点，并附热量信息。",
    all: "全部",
    fitHealthy: "轻食 / 健康",
    allMealsFilter: "所有餐次",
    allCuisines: "所有菜系",
    allWorldCuisines: "所有世界菜系",
    allDessertTypes: "所有甜点类型",
    dessertType: "甜点类型",
    newPlan: "新计划",
    loadingDaily: "正在准备每日计划...",
    loadingMeals: "正在加载菜肴...",
    loadingDesserts: "正在加载甜点...",
    totalDailyCalories: "今日三顿主餐的预估总热量",
    cachedPlan: "今日计划已从缓存加载。",
    noMealFound: "未找到菜肴",
    noDessertFound: "未找到甜点",
    tryDifferentFilters: "请更改筛选条件后重试。",
    mealsFound: "道菜肴",
    dessertsFound: "份甜点",
    noSlotSuggestion: "这些筛选条件下没有建议。",
    searchMeals: "搜索菜肴、菜系或食材...",
    searchDesserts: "搜索甜点或食材...",
    minutes: "分钟",
    kcal: "千卡",
    ingredientUnit: "种食材",
    addOwnRecipe: "添加自己的食谱",
    addRecipeIntro: "用几个简单步骤保存你的菜肴或甜点。",
    addRecipeLoginNote: "添加食谱前需要登录。",
    recipeName: "食谱名称",
    mealType: "餐次",
    calories: "热量",
    prepTime: "准备",
    cookTime: "烹饪",
    prepMinutes: "准备（分钟）",
    cookMinutes: "烹饪（分钟）",
    servings: "份数",
    ingredients: "食材",
    steps: "步骤",
    youtubeUrlPlaceholder: "https://www.youtube.com/watch?v=...",
    saving: "正在保存...",
    recipeSaved: "食谱已保存",
    ingredientsPlaceholder: "每行写一种食材，或用逗号分隔",
    stepsPlaceholder: "每行写一个步骤",
    recipeNamePlaceholder: "例如：家常蔬菜意面",
    rateRecipe: "评价此食谱",
    socialInfo: "社交登录结构已准备好，稍后可接入真实 OAuth 密钥。",
    favoriteAdd: "添加到收藏",
    favoriteRemove: "从收藏移除",
    favoriteAdded: "已添加到收藏",
    favoriteRemoved: "已从收藏移除",
    back: "返回",
    backToMeals: "返回菜肴",
    noMealSelected: "未选择菜肴",
    addAllIngredients: "将食材加入清单",
    addToList: "+ 清单",
    added: "已添加",
    alreadyOnList: "已在清单中",
    ingredientAdded: "已加入清单",
    ingredientsAddedToShopping: "食材已加入购物清单",
    videoRecipe: "视频食谱",
    rateLoginRequired: "请登录后评价。",
    ratingSaved: "评价已保存",
    noRatingYet: "暂无评价",
    dietitianIntro: "每天提供简短实用的营养和生活方式建议。",
    dailyNutritionAdvice: "每日营养与生活建议",
    dailyTips: "今日提示",
    suggestedFoodToday: "今日推荐食物：",
    adviceLoading: "正在准备今日建议...",
    adviceLoadFailed: "无法加载建议",
    checkBackendOrKey: "请检查后端连接或 API 密钥。",
    askDietitian: "询问营养师",
    medicalDisclaimer: "本部分仅供一般信息参考，不能替代诊断或治疗。",
    askPlaceholder: "例如：晚餐想吃清淡一点可以选什么？",
    answerPreparing: "正在准备回答...",
    cannotAnswerNow: "现在无法回答，请稍后再试。",
    wait: "等待",
    ask: "提问",
    favoritesIntro: "快速访问你喜欢的菜肴和甜点。",
    noFavorites: "暂无收藏食谱",
    favoriteHint: "点击食谱卡片上的爱心即可收藏。",
    browseMeals: "浏览菜肴",
    favoriteRecipeCount: "个收藏食谱",
    shoppingIntro: "持续管理从食谱添加的缺少食材。",
    list: "清单",
    waiting: "待处理",
    completed: "已完成",
    clearCompleted: "清除已完成",
    emptyList: "清单为空",
    shoppingEmptyHint: "可从食谱详情页添加食材。",
    purchased: "已购买",
    addNewIngredient: "添加新食材...",
    add: "添加",
    delete: "删除",
    purchasedCleared: "已清除已购买项目",
    ingredientSuggest: "按食材推荐",
    ingredientSuggestIntro: "输入你已有的食材，我们会找到合适食谱。",
    yourIngredients: "你的食材",
    addIngredientPlaceholder: "添加食材（例如：番茄、鸡蛋...）",
    searching: "搜索中...",
    findRecipe: "查找食谱",
    clear: "清空",
    searchingRecipes: "正在搜索食谱...",
    recipesFound: "个食谱",
    noMatchingRecipe: "未找到匹配食谱",
    tryDifferentIngredients: "请尝试其他食材。",
    match: "匹配度",
    availableIngredients: "可用食材",
    missingIngredients: "缺少食材：",
    addMissingToList: "将缺少食材加入清单",
    exactMatches: "完全匹配",
    partialMatches: "缺少食材的食谱",
    aiIngredientHelp: "AI 厨师建议",
    aiIngredientResult: "AI 厨师建议",
    ingredientAiLocked: "AI 建议已锁定",
    ingredientAiLockedHint: "非高级用户可观看激励广告，每天最多获得 3 次 AI 建议。",
    ingredientAiRewardConfirm: "你将观看激励广告模拟，以获得 1 次 AI 食材建议。继续吗？",
    watchAdForAi: "观看广告并获得 AI 建议",
    continueWith: "继续使用",
    requestFailed: "请求失败",
    translationNeedsKey: "完整食谱翻译需要 API 密钥；类别和标签已本地化。",
    admin: "管理",
    adminPanel: "管理面板",
    adminPanelIntro: "在发布前审核用户食谱。",
    adminAccessRequired: "需要管理员登录",
    adminAccessHint: "此区域仅对与 ADMIN_EMAIL 匹配的账户开放。",
    status: "状态",
    pending: "待审核",
    approved: "已批准",
    rejected: "已拒绝",
    loadingRecipes: "正在加载食谱...",
    noModerationRecipes: "没有需要审核的食谱",
    noModerationRecipesHint: "此状态下没有食谱。",
    approve: "批准",
    reject: "拒绝",
    preview: "预览",
    recipeApproved: "食谱已批准",
    recipeRejected: "食谱已拒绝",
    recipePendingReview: "食谱已保存并提交管理员审核。",
    emailAddress: "电子邮件地址",
    displayName: "显示名称",
    recipeImage: "食谱图片",
    recipeImageHint: "JPG、PNG 或 WEBP；最大 2 MB。",
    changeImage: "更换图片",
    recipeImageUpdated: "食谱图片已更新",
    saveChanges: "保存更改",
    recipeContentUpdated: "食谱内容已更新",
    recipeContentRequired: "食材和步骤不能为空。"
  }
});

Object.assign(EXTRA_TRANSLATIONS, {
  pt: {
    ...EXTRA_TRANSLATIONS.pt,
    designSettings: "Configurações de design",
    designSettingsIntro: "Altere o título do app, fontes, tamanho do texto, cores dos botões e ícones do menu.",
    appTitle: "Título do app",
    bodyFont: "Fonte do texto",
    headingFont: "Fonte dos títulos",
    baseFontSize: "Tamanho base do texto",
    headingScale: "Escala dos títulos",
    buttonRadius: "Arredondamento dos botões",
    primaryButtonColor: "Cor do botão principal",
    primaryButtonHover: "Cor do botão principal ao passar o cursor",
    successButtonColor: "Cor do botão verde",
    buttonTextColor: "Cor do texto do botão",
    saveDesignSettings: "Salvar design",
    designSettingsSaved: "Configurações de design salvas"
  },
  es: {
    ...EXTRA_TRANSLATIONS.es,
    designSettings: "Ajustes de diseño",
    designSettingsIntro: "Cambia el título de la app, fuentes, tamaño del texto, colores de botones e iconos del menú.",
    appTitle: "Título de la app",
    bodyFont: "Fuente del texto",
    headingFont: "Fuente de los títulos",
    baseFontSize: "Tamaño base del texto",
    headingScale: "Escala de títulos",
    buttonRadius: "Redondeo de botones",
    primaryButtonColor: "Color del botón principal",
    primaryButtonHover: "Color del botón principal al pasar el cursor",
    successButtonColor: "Color del botón verde",
    buttonTextColor: "Color del texto del botón",
    saveDesignSettings: "Guardar diseño",
    designSettingsSaved: "Ajustes de diseño guardados"
  },
  ja: {
    ...EXTRA_TRANSLATIONS.ja,
    designSettings: "デザイン設定",
    designSettingsIntro: "アプリ名、フォント、文字サイズ、ボタン色、メニューアイコンを変更します。",
    appTitle: "アプリ名",
    bodyFont: "本文フォント",
    headingFont: "見出しフォント",
    baseFontSize: "基本文字サイズ",
    headingScale: "見出し倍率",
    buttonRadius: "ボタンの角丸",
    primaryButtonColor: "メインボタン色",
    primaryButtonHover: "メインボタンのホバー色",
    successButtonColor: "緑ボタン色",
    buttonTextColor: "ボタン文字色",
    saveDesignSettings: "デザインを保存",
    designSettingsSaved: "デザイン設定を保存しました"
  },
  zh: {
    ...EXTRA_TRANSLATIONS.zh,
    designSettings: "设计设置",
    designSettingsIntro: "修改应用标题、字体、文字大小、按钮颜色和菜单图标。",
    appTitle: "应用标题",
    bodyFont: "正文字体",
    headingFont: "标题字体",
    baseFontSize: "基础文字大小",
    headingScale: "标题比例",
    buttonRadius: "按钮圆角",
    primaryButtonColor: "主按钮颜色",
    primaryButtonHover: "主按钮悬停颜色",
    successButtonColor: "绿色按钮颜色",
    buttonTextColor: "按钮文字颜色",
    saveDesignSettings: "保存设计",
    designSettingsSaved: "设计设置已保存"
  },
  ko: {
    ...EXTRA_TRANSLATIONS.ko,
    designSettings: "디자인 설정",
    designSettingsIntro: "앱 제목, 글꼴, 글자 크기, 버튼 색상과 메뉴 아이콘을 변경합니다.",
    appTitle: "앱 제목",
    bodyFont: "본문 글꼴",
    headingFont: "제목 글꼴",
    baseFontSize: "기본 글자 크기",
    headingScale: "제목 크기 비율",
    buttonRadius: "버튼 모서리",
    primaryButtonColor: "기본 버튼 색상",
    primaryButtonHover: "기본 버튼 호버 색상",
    successButtonColor: "초록 버튼 색상",
    buttonTextColor: "버튼 글자 색상",
    saveDesignSettings: "디자인 저장",
    designSettingsSaved: "디자인 설정이 저장되었습니다"
  },
  ar: {
    ...EXTRA_TRANSLATIONS.ar,
    designSettings: "إعدادات التصميم",
    designSettingsIntro: "غيّر عنوان التطبيق والخطوط وحجم النص وألوان الأزرار وأيقونات القائمة.",
    appTitle: "عنوان التطبيق",
    bodyFont: "خط النص",
    headingFont: "خط العناوين",
    baseFontSize: "حجم النص الأساسي",
    headingScale: "مقياس العناوين",
    buttonRadius: "استدارة الأزرار",
    primaryButtonColor: "لون الزر الرئيسي",
    primaryButtonHover: "لون الزر الرئيسي عند المرور",
    successButtonColor: "لون الزر الأخضر",
    buttonTextColor: "لون نص الزر",
    saveDesignSettings: "حفظ التصميم",
    designSettingsSaved: "تم حفظ إعدادات التصميم"
  }
});
